import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { getNotificationAll } from "../../actions/callManagementAction";
import "./AltSideMenu.scss";
import { Role } from "../../Roles";
import { wavesDark } from "./LandingSidemenu.module.scss";
import { utilConstants } from "../../constants/ActionTypes";
import hand_meet from "../../assets/images/hand_meet.svg";
import autoloanallocation from "../../assets/images/autoloanallocation.svg";
import processallocation from "../../assets/images/processallocation.svg";
import dialerreports from "../../assets/images/dialerreports.svg";
import predictiveupload from "../../assets/images/predictiveupload.svg";
import uploadIcon from "../../assets/images/Upload.svg.svg";

const newRoles = localStorage.getItem("role");
class Sidemenu extends Component {
  constructor(props) {
    super(props);
    const { _id, createdBy, role, client } = props.authentication?.collektoUser
      ? props.authentication?.collektoUser
      : {};
    this.role = role;
    this.idd = "CUSTOMER" === role ? client : _id;
    this.createdBy = createdBy;

    // this.props.getNotificationAll(this.idd, 0, role);
    this.state = {
      notificationLoans: [],
      // activeTab: "dashboard",
    };
  }

  componentWillReceiveProps(nextProps) {
    const { searchHistory } = nextProps.callmanagement;

    if (
      this.state.notificationLoans !==
      nextProps.callmanagement.notificationLoans
    ) {
      if (
        Boolean(searchHistory && typeof searchHistory === "object") &&
        !Object.keys(searchHistory).length
      ) {
        this.setState((prevState) => ({
          notificationLoans: [
            ...new Set(nextProps.callmanagement.allNotifications),
          ],
        }));
        this.setState((prevState) => ({
          totalLoans: [...new Set(nextProps.callmanagement.notificationLoans)],
        }));
      } else {
        this.setState(
          (prevState) => ({
            ...prevState,
            ...searchHistory,
          }),
          () => {
            this.forceUpdate();
          }
        );
      }
    }
  }
  static propsTypes = {
    authentication: PropTypes.object.isRequired,
    callmanagement: PropTypes.object.isRequired,
    getNotificationAll: PropTypes.func.isRequired,
  };

  reloadPage = () => {
    setTimeout(() => {
      window.location.reload();
    }, 0);
    //  = "/dev";
  };

  handleChangeTab = (newTab) => {
    this.props.dispatch({
      type: utilConstants.SET_ACTIVE_TAB,
      payload: newTab,
    });
  };

  isActive(currentTab) {
    // const { activeTab } = this.props.util || {};

    const location = this.props.location?.pathname;
    if (currentTab === location) {
      return "active";
    }
    return "";
  }

  render() {
    const { pathname } = this.props.location;

    const { collektoUser } = this.props.authentication;
    const role = collektoUser?.role.name;
    const { notificationLoans } = this.state;
    return (
      <aside className="left-sidebar admin ">
        <div className="">
          <nav className="sidebar-nav">
            <ul id="sidebarnav">
              {role !== Role.CRM_SUPERADMIN &&
                role !== Role.CRM_TENANTADMIN &&
                role !== Role.CRM_SUPERMANAGER && (
                  <li
                    className={this.isActive("/home")}
                    // onClick={() => this.handleChangeTab("home")}
                  >
                    {" "}
                    <NavLink
                      className="waves-effect waves-dark"
                      to={`/home`}
                      activeClassName="my-custom-active-class"
                      onClick={this.reloadPage}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M20.5153 9.7288L13.0153 2.65255C13.0116 2.64935 13.0082 2.6459 13.005 2.64223C12.7289 2.39111 12.369 2.25195 11.9958 2.25195C11.6225 2.25195 11.2627 2.39111 10.9866 2.64223L10.9763 2.65255L3.48469 9.7288C3.33187 9.86932 3.20989 10.04 3.12646 10.2301C3.04303 10.4202 2.99997 10.6256 3 10.8332V19.5004C3 19.8982 3.15804 20.2797 3.43934 20.561C3.72064 20.8423 4.10218 21.0004 4.5 21.0004H9C9.39782 21.0004 9.77936 20.8423 10.0607 20.561C10.342 20.2797 10.5 19.8982 10.5 19.5004V15.0004H13.5V19.5004C13.5 19.8982 13.658 20.2797 13.9393 20.561C14.2206 20.8423 14.6022 21.0004 15 21.0004H19.5C19.8978 21.0004 20.2794 20.8423 20.5607 20.561C20.842 20.2797 21 19.8982 21 19.5004V10.8332C21 10.6256 20.957 10.4202 20.8735 10.2301C20.7901 10.04 20.6681 9.86932 20.5153 9.7288ZM19.5 19.5004H15V15.0004C15 14.6025 14.842 14.221 14.5607 13.9397C14.2794 13.6584 13.8978 13.5004 13.5 13.5004H10.5C10.1022 13.5004 9.72064 13.6584 9.43934 13.9397C9.15804 14.221 9 14.6025 9 15.0004V19.5004H4.5V10.8332L4.51031 10.8238L12 3.75036L19.4906 10.8219L19.5009 10.8313L19.5 19.5004Z"
                          fill="#575757"
                        />
                      </svg>
                      <span className="hide-menu"> Home</span>
                    </NavLink>
                  </li>
                )}
              {collektoUser && collektoUser.role !== "CLIENT_ADMIN" && (
                <li
                  className={this.isActive("/")}
                  // onClick={() => this.handleChangeTab("dashboard")}
                >
                  {" "}
                  <NavLink
                    className="waves-effect waves-dark"
                    to={`/`}
                    activeClassName="my-custom-active-class"
                    // onClick={this.reloadPage}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M19.4119 7.56285C18.4397 6.58846 17.2842 5.81617 16.0121 5.29049C14.74 4.76482 13.3764 4.49617 12 4.50004H11.9625C6.19406 4.51973 1.5 9.28129 1.5 15.106V17.25C1.5 17.6479 1.65804 18.0294 1.93934 18.3107C2.22064 18.592 2.60218 18.75 3 18.75H21C21.3978 18.75 21.7794 18.592 22.0607 18.3107C22.342 18.0294 22.5 17.6479 22.5 17.25V15C22.5039 13.6176 22.2328 12.2482 21.7027 10.9714C21.1725 9.69461 20.3938 8.53598 19.4119 7.56285ZM21 17.25H11.2228L16.3566 10.1907C16.4737 10.0298 16.5221 9.82899 16.4911 9.63243C16.4602 9.43587 16.3524 9.25965 16.1916 9.14254C16.0307 9.02543 15.8299 8.97702 15.6333 9.00797C15.4368 9.03891 15.2605 9.14667 15.1434 9.30754L9.3675 17.25H3V15.106C3 14.8172 3.01406 14.5322 3.04031 14.25H5.25C5.44891 14.25 5.63968 14.171 5.78033 14.0304C5.92098 13.8897 6 13.699 6 13.5C6 13.3011 5.92098 13.1104 5.78033 12.9697C5.63968 12.8291 5.44891 12.75 5.25 12.75H3.30656C4.27406 9.10692 7.43156 6.35254 11.25 6.03192V8.25004C11.25 8.44895 11.329 8.63972 11.4697 8.78037C11.6103 8.92102 11.8011 9.00004 12 9.00004C12.1989 9.00004 12.3897 8.92102 12.5303 8.78037C12.671 8.63972 12.75 8.44895 12.75 8.25004V6.03098C14.6106 6.18756 16.3767 6.91813 17.8042 8.12175C19.2316 9.32537 20.2501 10.9426 20.7188 12.75H18.75C18.5511 12.75 18.3603 12.8291 18.2197 12.9697C18.079 13.1104 18 13.3011 18 13.5C18 13.699 18.079 13.8897 18.2197 14.0304C18.3603 14.171 18.5511 14.25 18.75 14.25H20.9691C20.9888 14.4985 21 14.7479 21 15V17.25Z"
                        fill="#575757"
                      />
                    </svg>
                    <span className="hide-menu"> Dashboard</span>
                  </NavLink>
                </li>
              )}

              {newRoles !== "CRM_TenantAdmin" && (
                <li
                  className={this.isActive("/agentProfiling")}
                  // onClick={() => this.handleChangeTab("agent-leadership")}
                >
                  <NavLink
                    className="waves-effect waves-dark"
                    to={`/agentProfiling`}
                    activeClassName="my-custom-active-class"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M20.25 3.75H12.75V2.25C12.75 2.05109 12.671 1.86032 12.5303 1.71967C12.3897 1.57902 12.1989 1.5 12 1.5C11.8011 1.5 11.6103 1.57902 11.4697 1.71967C11.329 1.86032 11.25 2.05109 11.25 2.25V3.75H3.75C3.35218 3.75 2.97064 3.90804 2.68934 4.18934C2.40804 4.47064 2.25 4.85218 2.25 5.25V16.5C2.25 16.8978 2.40804 17.2794 2.68934 17.5607C2.97064 17.842 3.35218 18 3.75 18H7.44L5.41406 20.5313C5.28974 20.6867 5.23225 20.8851 5.25422 21.0829C5.2762 21.2807 5.37585 21.4616 5.53125 21.5859C5.68665 21.7103 5.88507 21.7678 6.08286 21.7458C6.28066 21.7238 6.46162 21.6242 6.58594 21.4688L9.36 18H14.64L17.4141 21.4688C17.4756 21.5457 17.5517 21.6098 17.638 21.6573C17.7244 21.7048 17.8192 21.7349 17.9171 21.7458C18.0151 21.7567 18.1142 21.7481 18.2088 21.7207C18.3035 21.6933 18.3918 21.6475 18.4688 21.5859C18.5457 21.5244 18.6098 21.4483 18.6573 21.362C18.7048 21.2756 18.7349 21.1808 18.7458 21.0829C18.7567 20.9849 18.7481 20.8858 18.7207 20.7912C18.6933 20.6965 18.6475 20.6082 18.5859 20.5313L16.56 18H20.25C20.6478 18 21.0294 17.842 21.3107 17.5607C21.592 17.2794 21.75 16.8978 21.75 16.5V5.25C21.75 4.85218 21.592 4.47064 21.3107 4.18934C21.0294 3.90804 20.6478 3.75 20.25 3.75ZM20.25 16.5H3.75V5.25H20.25V16.5ZM9.75 11.25V13.5C9.75 13.6989 9.67098 13.8897 9.53033 14.0303C9.38968 14.171 9.19891 14.25 9 14.25C8.80109 14.25 8.61032 14.171 8.46967 14.0303C8.32902 13.8897 8.25 13.6989 8.25 13.5V11.25C8.25 11.0511 8.32902 10.8603 8.46967 10.7197C8.61032 10.579 8.80109 10.5 9 10.5C9.19891 10.5 9.38968 10.579 9.53033 10.7197C9.67098 10.8603 9.75 11.0511 9.75 11.25ZM12.75 9.75V13.5C12.75 13.6989 12.671 13.8897 12.5303 14.0303C12.3897 14.171 12.1989 14.25 12 14.25C11.8011 14.25 11.6103 14.171 11.4697 14.0303C11.329 13.8897 11.25 13.6989 11.25 13.5V9.75C11.25 9.55109 11.329 9.36032 11.4697 9.21967C11.6103 9.07902 11.8011 9 12 9C12.1989 9 12.3897 9.07902 12.5303 9.21967C12.671 9.36032 12.75 9.55109 12.75 9.75ZM15.75 8.25V13.5C15.75 13.6989 15.671 13.8897 15.5303 14.0303C15.3897 14.171 15.1989 14.25 15 14.25C14.8011 14.25 14.6103 14.171 14.4697 14.0303C14.329 13.8897 14.25 13.6989 14.25 13.5V8.25C14.25 8.05109 14.329 7.86032 14.4697 7.71967C14.6103 7.57902 14.8011 7.5 15 7.5C15.1989 7.5 15.3897 7.57902 15.5303 7.71967C15.671 7.86032 15.75 8.05109 15.75 8.25Z"
                        fill="#575757"
                      />
                    </svg>
                    <span className="hide-menu"> Agent Leadership Board</span>
                  </NavLink>
                </li>
              )}

              {collektoUser &&
                (collektoUser.role === "ADMIN" ||
                  role === Role.CRM_SUPERADMIN ||
                  role === Role.CRM_TENANTADMIN ||
                  role === Role.TENANT_ADMIN) && (
                  <React.Fragment>
                    <li
                      className={this.isActive("/loans")}
                      // onClick={() => this.handleChangeTab("allLoans")}
                    >
                      {" "}
                      <a
                        className="has-arrow waves-effect waves-dark"
                        data-toggle="collapse"
                        href="#loans"
                        aria-expanded="false"
                        activeClassName="my-custom-active-class"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M22.5 12.7496V18.7496C22.5 19.1474 22.342 19.529 22.0607 19.8103C21.7794 20.0916 21.3978 20.2496 21 20.2496H3C2.60218 20.2496 2.22064 20.0916 1.93934 19.8103C1.65804 19.529 1.5 19.1474 1.5 18.7496V12.7496C1.5 12.3518 1.65804 11.9703 1.93934 11.689C2.22064 11.4076 2.60218 11.2496 3 11.2496H7.5C7.69891 11.2496 7.88968 11.3286 8.03033 11.4693C8.17098 11.6099 8.25 11.8007 8.25 11.9996C8.25 12.1985 8.17098 12.3893 8.03033 12.5299C7.88968 12.6706 7.69891 12.7496 7.5 12.7496H3V18.7496H21V12.7496H16.5C16.3011 12.7496 16.1103 12.6706 15.9697 12.5299C15.829 12.3893 15.75 12.1985 15.75 11.9996C15.75 11.8007 15.829 11.6099 15.9697 11.4693C16.1103 11.3286 16.3011 11.2496 16.5 11.2496H21C21.3978 11.2496 21.7794 11.4076 22.0607 11.689C22.342 11.9703 22.5 12.3518 22.5 12.7496ZM8.03063 7.28024L11.25 4.05993V11.9996C11.25 12.1985 11.329 12.3893 11.4697 12.5299C11.6103 12.6706 11.8011 12.7496 12 12.7496C12.1989 12.7496 12.3897 12.6706 12.5303 12.5299C12.671 12.3893 12.75 12.1985 12.75 11.9996V4.05993L15.9694 7.28024C16.1101 7.42097 16.301 7.50003 16.5 7.50003C16.699 7.50003 16.8899 7.42097 17.0306 7.28024C17.1714 7.13951 17.2504 6.94864 17.2504 6.74961C17.2504 6.55059 17.1714 6.35972 17.0306 6.21899L12.5306 1.71899C12.461 1.64926 12.3783 1.59394 12.2872 1.55619C12.1962 1.51845 12.0986 1.49902 12 1.49902C11.9014 1.49902 11.8038 1.51845 11.7128 1.55619C11.6217 1.59394 11.539 1.64926 11.4694 1.71899L6.96937 6.21899C6.82864 6.35972 6.74958 6.55059 6.74958 6.74961C6.74958 6.94864 6.82864 7.13951 6.96938 7.28024C7.11011 7.42097 7.30098 7.50003 7.5 7.50003C7.69902 7.50003 7.88989 7.42097 8.03063 7.28024ZM18.75 15.7496C18.75 15.5271 18.684 15.3096 18.5604 15.1246C18.4368 14.9396 18.2611 14.7954 18.0555 14.7102C17.85 14.6251 17.6238 14.6028 17.4055 14.6462C17.1873 14.6896 16.9868 14.7968 16.8295 14.9541C16.6722 15.1115 16.565 15.3119 16.5216 15.5301C16.4782 15.7484 16.5005 15.9746 16.5856 16.1801C16.6708 16.3857 16.815 16.5614 17 16.685C17.185 16.8086 17.4025 16.8746 17.625 16.8746C17.9234 16.8746 18.2095 16.7561 18.4205 16.5451C18.6315 16.3341 18.75 16.048 18.75 15.7496Z"
                            fill="#575757"
                          />
                        </svg>
                        <span className="hide-menu">Import Accounts</span>
                      </a>
                      <ul aria-expanded="false" className="collapse" id="loans">
                        <li>
                          <NavLink to={`/loans`}>All Loans</NavLink>
                        </li>
                        {/* <li>
                          <NavLink to={`/loan/import-mapping`}>
                            Import Mapping
                          </NavLink>
                        </li> */}
                        <li>
                          <NavLink
                            to={{
                              pathname: `/loan/import-mapping-main`,
                              state: { isUpdateMapping: false },
                            }}
                          >
                            Import Mapping
                          </NavLink>
                        </li>
                        {/* /loan/import-mapping-new */}
                        <li>
                          <NavLink
                            to={{
                              pathname: `/loan/import-mapping-main`,
                              state: { isUpdateMapping: true },
                            }}
                          >
                            Update Import Mapping
                          </NavLink>
                        </li>
                        <li className={this.isActive("/loans/auto-allocation")}>
                          <NavLink
                            to={`/loans/auto-allocation`}
                            onClick={this.reloadPage}
                          >
                            Auto Loan Allocation
                          </NavLink>
                        </li>
                        {/* <li>
                          <NavLink to={`/loan/update-import-mapping`}>
                            Update Import Mapping
                          </NavLink>
                        </li> */}
                        {newRoles !== Role.CRM_TENANTADMIN &&
                          newRoles !== Role.CRM_SUPERADMIN && (
                            <>
                              <li className={this.isActive("/upload-loan")}>
                                <NavLink to={`/upload-loan`}>
                                  Import CSV
                                </NavLink>
                              </li>

                              <li
                                className={this.isActive("/loan/manual-entry")}
                              >
                                <NavLink to={`/loan/manual-entry`}>
                                  Manual Account Entry
                                </NavLink>
                              </li>
                            </>
                          )}
                        {newRoles !== Role.CRM_SUPERADMIN && (
                          <li className={this.isActive("/extend-loan")}>
                            <NavLink to={`/extend-loans`}>Extend Loans</NavLink>
                          </li>
                        )}
                      </ul>
                    </li>
                    {newRoles !== Role.CRM_TENANTADMIN &&
                      newRoles !== Role.CRM_SUPERADMIN && (
                        <li className={this.isActive("/data-insights")}>
                          {" "}
                          <a
                            className="has-arrow waves-effect waves-dark"
                            data-toggle="collapse"
                            href="#loans"
                            aria-expanded="false"
                            activeClassName="my-custom-active-class"
                          >
                            <i className="fa fa-television"></i>
                            <span className="hide-menu">Data Insights</span>
                          </a>
                          <ul
                            aria-expanded="false"
                            className="collapse"
                            id="loans"
                            onClick={() => this.handleChangeTab("dataInsight")}
                          >
                            <li>
                              {" "}
                              <NavLink to={`/data-insights`}>Dashboard</NavLink>
                              <li>
                                <NavLink to={`/data-insights-file`}>
                                  File Upload DataInsight
                                </NavLink>
                              </li>
                            </li>
                          </ul>
                        </li>
                      )}
                    {/* 
                    <li className={this.isActive("managers-collectors")}>
                      {" "}
                      <NavLink
                        className="waves-effect waves-dark"
                        to={`/old-managers-collectors`}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M13.4994 7.49965C13.4994 7.30074 13.5784 7.10998 13.719 6.96932C13.8597 6.82867 14.0504 6.74965 14.2494 6.74965H23.2494C23.4483 6.74965 23.639 6.82867 23.7797 6.96932C23.9203 7.10998 23.9994 7.30074 23.9994 7.49965C23.9994 7.69857 23.9203 7.88933 23.7797 8.02998C23.639 8.17064 23.4483 8.24965 23.2494 8.24965H14.2494C14.0504 8.24965 13.8597 8.17064 13.719 8.02998C13.5784 7.88933 13.4994 7.69857 13.4994 7.49965ZM23.2494 11.2497H14.2494C14.0504 11.2497 13.8597 11.3287 13.719 11.4693C13.5784 11.61 13.4994 11.8007 13.4994 11.9997C13.4994 12.1986 13.5784 12.3893 13.719 12.53C13.8597 12.6706 14.0504 12.7497 14.2494 12.7497H23.2494C23.4483 12.7497 23.639 12.6706 23.7797 12.53C23.9203 12.3893 23.9994 12.1986 23.9994 11.9997C23.9994 11.8007 23.9203 11.61 23.7797 11.4693C23.639 11.3287 23.4483 11.2497 23.2494 11.2497ZM23.2494 15.7497H16.4994C16.3004 15.7497 16.1097 15.8287 15.969 15.9693C15.8284 16.11 15.7494 16.3007 15.7494 16.4997C15.7494 16.6986 15.8284 16.8893 15.969 17.03C16.1097 17.1706 16.3004 17.2497 16.4994 17.2497H23.2494C23.4483 17.2497 23.639 17.1706 23.7797 17.03C23.9203 16.8893 23.9994 16.6986 23.9994 16.4997C23.9994 16.3007 23.9203 16.11 23.7797 15.9693C23.639 15.8287 23.4483 15.7497 23.2494 15.7497ZM14.2259 17.8122C14.2504 17.9076 14.2559 18.0069 14.242 18.1044C14.2282 18.2019 14.1952 18.2958 14.1451 18.3806C14.0949 18.4654 14.0286 18.5395 13.9498 18.5986C13.871 18.6578 13.7813 18.7008 13.6859 18.7253C13.6248 18.7418 13.5617 18.75 13.4984 18.7497C13.3321 18.7497 13.1704 18.6945 13.0389 18.5927C12.9074 18.4909 12.8134 18.3482 12.7719 18.1872C12.1944 15.9428 9.92748 14.2497 7.49841 14.2497C5.06935 14.2497 2.80248 15.9418 2.22498 18.1872C2.17525 18.3799 2.05101 18.5449 1.87959 18.646C1.70817 18.7471 1.50361 18.7759 1.31092 18.7262C1.11822 18.6765 0.953169 18.5522 0.852075 18.3808C0.750981 18.2094 0.722125 18.0049 0.771853 17.8122C1.29592 15.7768 2.81935 14.1287 4.75248 13.3122C4.00813 12.7388 3.4619 11.9469 3.1904 11.0475C2.9189 10.148 2.93573 9.18611 3.23855 8.29671C3.54137 7.4073 4.11498 6.63498 4.87893 6.08806C5.64289 5.54115 6.55887 5.24707 7.49841 5.24707C8.43796 5.24707 9.35394 5.54115 10.1179 6.08806C10.8819 6.63498 11.4555 7.4073 11.7583 8.29671C12.0611 9.18611 12.0779 10.148 11.8064 11.0475C11.5349 11.9469 10.9887 12.7388 10.2444 13.3122C12.1784 14.1287 13.7019 15.7768 14.2259 17.8122ZM7.49935 12.7497C8.0927 12.7497 8.67272 12.5737 9.16606 12.2441C9.65941 11.9144 10.0439 11.4459 10.271 10.8977C10.4981 10.3495 10.5575 9.74633 10.4417 9.16438C10.326 8.58244 10.0402 8.04789 9.62067 7.62833C9.20112 7.20878 8.66657 6.92305 8.08462 6.8073C7.50268 6.69154 6.89948 6.75095 6.3513 6.97802C5.80312 7.20508 5.33459 7.5896 5.00494 8.08294C4.6753 8.57629 4.49935 9.15631 4.49935 9.74965C4.49935 10.5453 4.81542 11.3084 5.37803 11.871C5.94064 12.4336 6.7037 12.7497 7.49935 12.7497Z"
                            fill="#575757"
                          />
                        </svg>
                        <span onClick={() => this.handleChangeTab("managers-collectors")} className="hide-menu">Managers & Collectors</span>
                      </NavLink>
                    </li> */}

                    <li className={this.isActive("/managers-collectors")}>
                      {" "}
                      <NavLink
                        className="waves-effect waves-dark"
                        to={`/managers-collectors`}
                        activeClassName="my-custom-active-class"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M13.4994 7.49965C13.4994 7.30074 13.5784 7.10998 13.719 6.96932C13.8597 6.82867 14.0504 6.74965 14.2494 6.74965H23.2494C23.4483 6.74965 23.639 6.82867 23.7797 6.96932C23.9203 7.10998 23.9994 7.30074 23.9994 7.49965C23.9994 7.69857 23.9203 7.88933 23.7797 8.02998C23.639 8.17064 23.4483 8.24965 23.2494 8.24965H14.2494C14.0504 8.24965 13.8597 8.17064 13.719 8.02998C13.5784 7.88933 13.4994 7.69857 13.4994 7.49965ZM23.2494 11.2497H14.2494C14.0504 11.2497 13.8597 11.3287 13.719 11.4693C13.5784 11.61 13.4994 11.8007 13.4994 11.9997C13.4994 12.1986 13.5784 12.3893 13.719 12.53C13.8597 12.6706 14.0504 12.7497 14.2494 12.7497H23.2494C23.4483 12.7497 23.639 12.6706 23.7797 12.53C23.9203 12.3893 23.9994 12.1986 23.9994 11.9997C23.9994 11.8007 23.9203 11.61 23.7797 11.4693C23.639 11.3287 23.4483 11.2497 23.2494 11.2497ZM23.2494 15.7497H16.4994C16.3004 15.7497 16.1097 15.8287 15.969 15.9693C15.8284 16.11 15.7494 16.3007 15.7494 16.4997C15.7494 16.6986 15.8284 16.8893 15.969 17.03C16.1097 17.1706 16.3004 17.2497 16.4994 17.2497H23.2494C23.4483 17.2497 23.639 17.1706 23.7797 17.03C23.9203 16.8893 23.9994 16.6986 23.9994 16.4997C23.9994 16.3007 23.9203 16.11 23.7797 15.9693C23.639 15.8287 23.4483 15.7497 23.2494 15.7497ZM14.2259 17.8122C14.2504 17.9076 14.2559 18.0069 14.242 18.1044C14.2282 18.2019 14.1952 18.2958 14.1451 18.3806C14.0949 18.4654 14.0286 18.5395 13.9498 18.5986C13.871 18.6578 13.7813 18.7008 13.6859 18.7253C13.6248 18.7418 13.5617 18.75 13.4984 18.7497C13.3321 18.7497 13.1704 18.6945 13.0389 18.5927C12.9074 18.4909 12.8134 18.3482 12.7719 18.1872C12.1944 15.9428 9.92748 14.2497 7.49841 14.2497C5.06935 14.2497 2.80248 15.9418 2.22498 18.1872C2.17525 18.3799 2.05101 18.5449 1.87959 18.646C1.70817 18.7471 1.50361 18.7759 1.31092 18.7262C1.11822 18.6765 0.953169 18.5522 0.852075 18.3808C0.750981 18.2094 0.722125 18.0049 0.771853 17.8122C1.29592 15.7768 2.81935 14.1287 4.75248 13.3122C4.00813 12.7388 3.4619 11.9469 3.1904 11.0475C2.9189 10.148 2.93573 9.18611 3.23855 8.29671C3.54137 7.4073 4.11498 6.63498 4.87893 6.08806C5.64289 5.54115 6.55887 5.24707 7.49841 5.24707C8.43796 5.24707 9.35394 5.54115 10.1179 6.08806C10.8819 6.63498 11.4555 7.4073 11.7583 8.29671C12.0611 9.18611 12.0779 10.148 11.8064 11.0475C11.5349 11.9469 10.9887 12.7388 10.2444 13.3122C12.1784 14.1287 13.7019 15.7768 14.2259 17.8122ZM7.49935 12.7497C8.0927 12.7497 8.67272 12.5737 9.16606 12.2441C9.65941 11.9144 10.0439 11.4459 10.271 10.8977C10.4981 10.3495 10.5575 9.74633 10.4417 9.16438C10.326 8.58244 10.0402 8.04789 9.62067 7.62833C9.20112 7.20878 8.66657 6.92305 8.08462 6.8073C7.50268 6.69154 6.89948 6.75095 6.3513 6.97802C5.80312 7.20508 5.33459 7.5896 5.00494 8.08294C4.6753 8.57629 4.49935 9.15631 4.49935 9.74965C4.49935 10.5453 4.81542 11.3084 5.37803 11.871C5.94064 12.4336 6.7037 12.7497 7.49935 12.7497Z"
                            fill="#575757"
                          />
                        </svg>
                        <span
                          // onClick={() =>
                          //   this.handleChangeTab("new-managers-collectors")
                          // }
                          className="hide-menu"
                        >
                          Roles & Hierarchy
                        </span>
                      </NavLink>
                    </li>
                    <li className={this.isActive("portfolioControlPanel")}>
                      {" "}
                      <a
                        className="has-arrow waves-effect waves-dark"
                        data-toggle="collapse"
                        href="#loans"
                        aria-expanded="false"
                        activeClassName="my-custom-active-class"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="30"
                          viewBox="0 0 36 36"
                          fill="none"
                        >
                          <path
                            d="M27.862 27.4008C28 27.5648 28.0883 27.7649 28.1164 27.9774C28.1445 28.1899 28.1113 28.406 28.0208 28.6003C27.9302 28.7946 27.786 28.959 27.6052 29.0741C27.4243 29.1892 27.2143 29.2502 27 29.25H3.37498C3.16073 29.25 2.95095 29.1887 2.77032 29.0735C2.58968 28.9583 2.44569 28.7939 2.35529 28.5997C2.26489 28.4055 2.23184 28.1894 2.26002 27.977C2.28819 27.7647 2.37643 27.5647 2.51435 27.4008C4.61529 24.9005 7.22811 23.1244 10.132 22.1738C8.36844 21.0753 7.01059 19.4324 6.26389 17.4936C5.51719 15.5547 5.42227 13.4254 5.99349 11.4278C6.56471 9.43023 7.77099 7.67302 9.42983 6.42204C11.0887 5.17106 13.1098 4.49438 15.1875 4.49438C17.2651 4.49438 19.2863 5.17106 20.9451 6.42204C22.604 7.67302 23.8103 9.43023 24.3815 11.4278C24.9527 13.4254 24.8578 15.5547 24.1111 17.4936C23.3644 19.4324 22.0065 21.0753 20.2429 22.1738C23.1469 23.1244 25.7597 24.9005 27.862 27.4008ZM34.7597 21.6563C34.6608 21.8275 34.5185 21.9697 34.3472 22.0685C34.1758 22.1672 33.9815 22.219 33.7837 22.2188C33.5862 22.2194 33.3921 22.1674 33.2212 22.0683L32.5645 21.6886C32.2502 21.9582 31.8889 22.1675 31.4986 22.3059V23.0625C31.4986 23.3609 31.3801 23.647 31.1691 23.858C30.9581 24.069 30.6719 24.1875 30.3736 24.1875C30.0752 24.1875 29.7891 24.069 29.5781 23.858C29.3671 23.647 29.2486 23.3609 29.2486 23.0625V22.3059C28.8583 22.1675 28.4969 21.9582 28.1826 21.6886L27.5259 22.0683C27.3551 22.1674 27.1609 22.2194 26.9634 22.2188C26.7157 22.2189 26.4749 22.1372 26.2783 21.9864C26.0817 21.8356 25.9404 21.6242 25.8763 21.3849C25.8122 21.1456 25.8289 20.8918 25.9237 20.663C26.0186 20.4341 26.1863 20.243 26.4009 20.1192L27.0562 19.7409C26.9794 19.3339 26.9794 18.9161 27.0562 18.5091L26.4009 18.1308C26.2729 18.0569 26.1608 17.9586 26.0708 17.8413C25.9808 17.7241 25.9148 17.5903 25.8766 17.4476C25.8383 17.3049 25.8285 17.156 25.8478 17.0095C25.8671 16.863 25.915 16.7217 25.9889 16.5938C26.0628 16.4658 26.1611 16.3536 26.2783 16.2636C26.3956 16.1737 26.5293 16.1077 26.6721 16.0694C26.8148 16.0312 26.9637 16.0214 27.1102 16.0406C27.2567 16.0599 27.3979 16.1079 27.5259 16.1817L28.1826 16.5614C28.4969 16.2918 28.8583 16.0825 29.2486 15.9441V15.1875C29.2486 14.8891 29.3671 14.603 29.5781 14.392C29.7891 14.181 30.0752 14.0625 30.3736 14.0625C30.6719 14.0625 30.9581 14.181 31.1691 14.392C31.3801 14.603 31.4986 14.8891 31.4986 15.1875V15.9441C31.8889 16.0825 32.2502 16.2918 32.5645 16.5614L33.2212 16.1817C33.3492 16.1079 33.4905 16.0599 33.637 16.0406C33.7835 16.0214 33.9324 16.0312 34.0751 16.0694C34.2178 16.1077 34.3516 16.1737 34.4688 16.2636C34.586 16.3536 34.6844 16.4658 34.7583 16.5938C34.8321 16.7217 34.8801 16.863 34.8993 17.0095C34.9186 17.156 34.9088 17.3049 34.8706 17.4476C34.8323 17.5903 34.7663 17.7241 34.6764 17.8413C34.5864 17.9586 34.4742 18.0569 34.3462 18.1308L33.6909 18.5091C33.7678 18.9161 33.7678 19.3339 33.6909 19.7409L34.3462 20.1192C34.4743 20.193 34.5867 20.2912 34.6768 20.4084C34.7669 20.5255 34.8331 20.6593 34.8715 20.8021C34.9099 20.9448 34.9198 21.0937 34.9006 21.2403C34.8814 21.3869 34.8335 21.5282 34.7597 21.6563ZM30.375 20.25C30.5975 20.25 30.815 20.184 31 20.0604C31.185 19.9368 31.3292 19.7611 31.4143 19.5555C31.4995 19.35 31.5218 19.1238 31.4784 18.9055C31.435 18.6873 31.3278 18.4868 31.1705 18.3295C31.0131 18.1722 30.8127 18.065 30.5945 18.0216C30.3762 17.9782 30.15 18.0005 29.9445 18.0856C29.7389 18.1708 29.5632 18.315 29.4396 18.5C29.316 18.685 29.25 18.9025 29.25 19.125C29.25 19.4234 29.3685 19.7095 29.5795 19.9205C29.7905 20.1315 30.0766 20.25 30.375 20.25Z"
                            fill="#575757"
                          />
                        </svg>
                        <span
                          // onClick={() =>
                          //   this.handleChangeTab("portfolioControlPanel")
                          // }
                          className="hide-menu"
                        >
                          Portfolio Control Panel
                        </span>
                      </a>
                      <ul
                        aria-expanded="false"
                        className="collapse"
                        id="loans"
                        // onClick={() =>
                        //   this.handleChangeTab("portfolioControlPanel")
                        // }
                      >
                        <li>
                          {" "}
                          <NavLink
                            to={`/create-portfolio`}
                            onClick={this.reloadPage}
                            activeClassName="my-custom-active-class"
                          >
                            Create Portfolio
                          </NavLink>
                          <li>
                            <NavLink
                              to={`/view-client`}
                              onClick={this.reloadPage}
                              activeClassName="my-custom-active-class"
                            >
                              View Portfolio
                            </NavLink>
                          </li>
                        </li>
                      </ul>
                    </li>

                    {/* <li className={this.isActive("clientControlPanel")}>
                      {" "}
                      <a
                        className="has-arrow waves-effect waves-dark"
                        data-toggle="collapse"
                        href="#loans"
                        aria-expanded="false"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="30"
                          viewBox="0 0 36 36"
                          fill="none"
                        >
                          <path
                            d="M27.862 27.4008C28 27.5648 28.0883 27.7649 28.1164 27.9774C28.1445 28.1899 28.1113 28.406 28.0208 28.6003C27.9302 28.7946 27.786 28.959 27.6052 29.0741C27.4243 29.1892 27.2143 29.2502 27 29.25H3.37498C3.16073 29.25 2.95095 29.1887 2.77032 29.0735C2.58968 28.9583 2.44569 28.7939 2.35529 28.5997C2.26489 28.4055 2.23184 28.1894 2.26002 27.977C2.28819 27.7647 2.37643 27.5647 2.51435 27.4008C4.61529 24.9005 7.22811 23.1244 10.132 22.1738C8.36844 21.0753 7.01059 19.4324 6.26389 17.4936C5.51719 15.5547 5.42227 13.4254 5.99349 11.4278C6.56471 9.43023 7.77099 7.67302 9.42983 6.42204C11.0887 5.17106 13.1098 4.49438 15.1875 4.49438C17.2651 4.49438 19.2863 5.17106 20.9451 6.42204C22.604 7.67302 23.8103 9.43023 24.3815 11.4278C24.9527 13.4254 24.8578 15.5547 24.1111 17.4936C23.3644 19.4324 22.0065 21.0753 20.2429 22.1738C23.1469 23.1244 25.7597 24.9005 27.862 27.4008ZM34.7597 21.6563C34.6608 21.8275 34.5185 21.9697 34.3472 22.0685C34.1758 22.1672 33.9815 22.219 33.7837 22.2188C33.5862 22.2194 33.3921 22.1674 33.2212 22.0683L32.5645 21.6886C32.2502 21.9582 31.8889 22.1675 31.4986 22.3059V23.0625C31.4986 23.3609 31.3801 23.647 31.1691 23.858C30.9581 24.069 30.6719 24.1875 30.3736 24.1875C30.0752 24.1875 29.7891 24.069 29.5781 23.858C29.3671 23.647 29.2486 23.3609 29.2486 23.0625V22.3059C28.8583 22.1675 28.4969 21.9582 28.1826 21.6886L27.5259 22.0683C27.3551 22.1674 27.1609 22.2194 26.9634 22.2188C26.7157 22.2189 26.4749 22.1372 26.2783 21.9864C26.0817 21.8356 25.9404 21.6242 25.8763 21.3849C25.8122 21.1456 25.8289 20.8918 25.9237 20.663C26.0186 20.4341 26.1863 20.243 26.4009 20.1192L27.0562 19.7409C26.9794 19.3339 26.9794 18.9161 27.0562 18.5091L26.4009 18.1308C26.2729 18.0569 26.1608 17.9586 26.0708 17.8413C25.9808 17.7241 25.9148 17.5903 25.8766 17.4476C25.8383 17.3049 25.8285 17.156 25.8478 17.0095C25.8671 16.863 25.915 16.7217 25.9889 16.5938C26.0628 16.4658 26.1611 16.3536 26.2783 16.2636C26.3956 16.1737 26.5293 16.1077 26.6721 16.0694C26.8148 16.0312 26.9637 16.0214 27.1102 16.0406C27.2567 16.0599 27.3979 16.1079 27.5259 16.1817L28.1826 16.5614C28.4969 16.2918 28.8583 16.0825 29.2486 15.9441V15.1875C29.2486 14.8891 29.3671 14.603 29.5781 14.392C29.7891 14.181 30.0752 14.0625 30.3736 14.0625C30.6719 14.0625 30.9581 14.181 31.1691 14.392C31.3801 14.603 31.4986 14.8891 31.4986 15.1875V15.9441C31.8889 16.0825 32.2502 16.2918 32.5645 16.5614L33.2212 16.1817C33.3492 16.1079 33.4905 16.0599 33.637 16.0406C33.7835 16.0214 33.9324 16.0312 34.0751 16.0694C34.2178 16.1077 34.3516 16.1737 34.4688 16.2636C34.586 16.3536 34.6844 16.4658 34.7583 16.5938C34.8321 16.7217 34.8801 16.863 34.8993 17.0095C34.9186 17.156 34.9088 17.3049 34.8706 17.4476C34.8323 17.5903 34.7663 17.7241 34.6764 17.8413C34.5864 17.9586 34.4742 18.0569 34.3462 18.1308L33.6909 18.5091C33.7678 18.9161 33.7678 19.3339 33.6909 19.7409L34.3462 20.1192C34.4743 20.193 34.5867 20.2912 34.6768 20.4084C34.7669 20.5255 34.8331 20.6593 34.8715 20.8021C34.9099 20.9448 34.9198 21.0937 34.9006 21.2403C34.8814 21.3869 34.8335 21.5282 34.7597 21.6563ZM30.375 20.25C30.5975 20.25 30.815 20.184 31 20.0604C31.185 19.9368 31.3292 19.7611 31.4143 19.5555C31.4995 19.35 31.5218 19.1238 31.4784 18.9055C31.435 18.6873 31.3278 18.4868 31.1705 18.3295C31.0131 18.1722 30.8127 18.065 30.5945 18.0216C30.3762 17.9782 30.15 18.0005 29.9445 18.0856C29.7389 18.1708 29.5632 18.315 29.4396 18.5C29.316 18.685 29.25 18.9025 29.25 19.125C29.25 19.4234 29.3685 19.7095 29.5795 19.9205C29.7905 20.1315 30.0766 20.25 30.375 20.25Z"
                            fill="#575757"
                          />
                        </svg>
                        <span className="hide-menu">Client Control Panel</span>
                      </a>
                      <ul aria-expanded="false" className="collapse" id="loans" onClick={() => this.handleChangeTab("clientControlPanel")}>
                        <li>
                          {" "}
                          <NavLink to={`/create-client`} onClick={this.reloadPage}>
                            Add Client
                          </NavLink>
                          <li>
                            <NavLink to={`/view-client`} onClick={this.reloadPage}>
                              View Clients
                            </NavLink>
                          </li>
                        </li>
                      </ul>
                    </li> */}

                    <li className={this.isActive("/process-allocation")}>
                      {" "}
                      <NavLink
                        className="waves-effect waves-dark"
                        to={`/process-allocation`}
                        onClick={this.reloadPage}
                        activeClassName="my-custom-active-class"
                      >
                        <div className="icon-wrapper">
                          <img
                            src={processallocation}
                            alt="Process Allocation Icon"
                            className="icon"
                          />
                        </div>

                        <span
                          onClick={() =>
                            this.handleChangeTab("processAllocation")
                          }
                          className="hide-menu"
                        >
                          Process Allocation
                        </span>
                      </NavLink>
                    </li>

                    {(newRoles === Role.CRM_TENANTADMIN ||
                      newRoles === Role.CRM_SUPERADMIN) && (
                      <li className={this.isActive("/Predictive-upload")}>
                        {" "}
                        <NavLink
                          className="waves-effect waves-dark"
                          to={`/Predictive-upload`}
                          // onClick={this.reloadPage}
                          activeClassName="my-custom-active-class"
                        >
                          <div className="icon-wrapper">
                            <img
                              src={predictiveupload}
                              alt="Process Allocation Icon"
                              className="icon"
                            />
                          </div>
                          <span
                            onClick={() =>
                              this.handleChangeTab("Predictive-upload")
                            }
                            className="hide-menu"
                          >
                            Predictive upload
                          </span>
                        </NavLink>
                      </li>
                    )}

                    {(newRoles === Role.CRM_TENANTADMIN ||
                      newRoles === Role.CRM_SUPERADMIN) && (
                      <li className={this.isActive("/suppression-list")}>
                        {" "}
                        <NavLink
                          className="waves-effect waves-dark"
                          to={`/suppression-list`}
                          onClick={this.reloadPage}
                          activeClassName="my-custom-active-class"
                        >
                          <img src={uploadIcon} />
                          <span
                            onClick={() =>
                              this.handleChangeTab("suprpession-list")
                            }
                            className="hide-menu"
                          >
                            Suppression List
                          </span>
                        </NavLink>
                      </li>
                    )}

                    <li className={this.isActive("/Reconciliation")}>
                      {" "}
                      <NavLink
                        className="waves-effect waves-dark"
                        to={`/Reconciliation`}
                        onClick={this.reloadPage}
                        activeClassName="my-custom-active-class"
                      >
                        <img src={hand_meet} />
                        <span
                          className="hide-menu"
                          onClick={() => this.handleChangeTab("reconciliation")}
                        >
                          Reconciliation
                        </span>
                      </NavLink>
                    </li>

                    {newRoles !== Role.CRM_TENANTADMIN &&
                      newRoles !== Role.CRM_SUPERADMIN && (
                        <li className={this.isActive("/revenues")}>
                          {" "}
                          <a
                            className="has-arrow waves-effect waves-dark"
                            data-toggle="collapse"
                            href="#loans"
                            activeClassName="my-custom-active-class"
                            aria-expanded="false"
                          >
                            <i className="fa fa-user"></i>
                            <span className="hide-menu">Revenue</span>
                          </a>
                          <ul
                            aria-expanded="false"
                            className="collapse"
                            id="loans"
                            onClick={() => this.handleChangeTab("revenue")}
                          >
                            <li>
                              {" "}
                              <NavLink to={`/revenues`}>
                                Employee Revenue
                              </NavLink>
                            </li>
                            <li>
                              {" "}
                              <NavLink to={`/client-revenue`}>
                                Client Revenue
                              </NavLink>
                            </li>

                            <li>
                              {" "}
                              <NavLink to={`/success-fees`}>
                                Success Fees
                              </NavLink>
                            </li>
                          </ul>
                        </li>
                      )}

                    {newRoles !== Role.CRM_TENANTADMIN &&
                      newRoles !== Role.CRM_SUPERADMIN && (
                        <li className={this.isActive("recoveryPredictor")}>
                          {" "}
                          <a
                            className="has-arrow waves-effect waves-dark"
                            data-toggle="collapse"
                            href="#loans"
                            aria-expanded="false"
                            activeClassName="my-custom-active-class"
                          >
                            <i className="fa fa-bar-chart"></i>
                            <span className="hide-menu">
                              Recovery Predictor
                            </span>
                          </a>
                          <ul
                            aria-expanded="false"
                            className="collapse"
                            id="loans"
                            onClick={() =>
                              this.handleChangeTab("recoveryPredictor")
                            }
                          >
                            <li>
                              <NavLink to={`/Recovery`}>
                                {" "}
                                Basic Predictor{" "}
                              </NavLink>
                              <li>
                                {" "}
                                <NavLink to={`/recovery-insight`}>
                                  {" "}
                                  Advanced Predictor{" "}
                                </NavLink>
                              </li>
                            </li>
                          </ul>
                        </li>
                      )}

                    {newRoles !== Role.CRM_TENANTADMIN &&
                      newRoles !== Role.CRM_SUPERADMIN && (
                        <li className={this.isActive("partners-clients")}>
                          {" "}
                          <a
                            className="has-arrow waves-effect waves-dark"
                            data-toggle="collapse"
                            href="#loans"
                            aria-expanded="false"
                            activeClassName="my-custom-active-class"
                          >
                            <i className="fa fa-users"></i>
                            <span className="hide-menu">Partners/Clients</span>
                          </a>
                          <ul
                            aria-expanded="false"
                            className="collapse"
                            id="loans"
                            onClick={() =>
                              this.handleChangeTab("partners-clients")
                            }
                          >
                            <li>
                              {" "}
                              <NavLink to={`/clients`}>Clients</NavLink>
                            </li>

                            <li>
                              {" "}
                              <NavLink to={`/partner-list`}>Partners</NavLink>
                            </li>
                          </ul>
                        </li>
                      )}

                    {newRoles !== Role.CRM_TENANTADMIN &&
                      newRoles !== Role.CRM_SUPERADMIN && (
                        <li className={this.isActive("rule-engine")}>
                          {" "}
                          <a
                            className="has-arrow waves-effect waves-dark"
                            data-toggle="collapse"
                            href="#portfolios"
                            aria-expanded="false"
                            activeClassName="my-custom-active-class"
                          >
                            <i className="icon-screen-desktop" />
                            <span className="hide-menu">Rule Engine</span>
                          </a>
                          <ul
                            aria-expanded="false"
                            className="collapse"
                            id="portfolios"
                            onClick={() => this.handleChangeTab("rule-engine")}
                          >
                            <li>
                              <NavLink to={`/allocation-rule`}>
                                New Rule Engine
                              </NavLink>
                            </li>
                            <li>
                              <NavLink to={`/allocation-rule-loans`}>
                                Rule loans list
                              </NavLink>
                            </li>
                          </ul>
                        </li>
                      )}
                  </React.Fragment>
                )}

              {role === Role.CRM_TELECALLER && (
                <React.Fragment>
                  <li className={this.isActive("/loans")}>
                    {" "}
                    <NavLink className="waves-effect waves-dark" to={`/loans`}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_17818_10489)">
                          <path
                            d="M21.5934 13.2244C21.3144 13.0096 20.9895 12.8622 20.6442 12.7934C20.2988 12.7246 19.9422 12.7364 19.6022 12.8278L15.6797 13.7297C15.7709 13.3442 15.7738 12.943 15.6879 12.5563C15.6021 12.1695 15.4298 11.8072 15.1841 11.4965C14.9383 11.1858 14.6254 10.9347 14.2688 10.7622C13.9122 10.5896 13.5212 10.5 13.125 10.5H8.43188C8.03775 10.499 7.64733 10.5761 7.28319 10.7269C6.91904 10.8777 6.58838 11.0991 6.31031 11.3784L4.18969 13.5H1.5C1.10218 13.5 0.720644 13.658 0.43934 13.9393C0.158035 14.2206 0 14.6022 0 15L0 18.75C0 19.1478 0.158035 19.5294 0.43934 19.8107C0.720644 20.092 1.10218 20.25 1.5 20.25H11.25C11.3113 20.25 11.3724 20.2425 11.4319 20.2275L17.4319 18.7275C17.4701 18.7184 17.5075 18.7058 17.5434 18.69L21.1875 17.1394L21.2288 17.1206C21.579 16.9456 21.8789 16.6843 22.1002 16.3614C22.3215 16.0385 22.457 15.6645 22.4939 15.2747C22.5307 14.8849 22.4678 14.4922 22.3109 14.1335C22.154 13.7748 21.9084 13.4619 21.5972 13.2244H21.5934ZM1.5 15H3.75V18.75H1.5V15ZM20.5716 15.7697L17.0091 17.2866L11.1562 18.75H5.25V14.5603L7.37156 12.4397C7.51035 12.2998 7.67555 12.1889 7.85758 12.1134C8.03961 12.0379 8.23482 11.9994 8.43188 12H13.125C13.4234 12 13.7095 12.1185 13.9205 12.3295C14.1315 12.5405 14.25 12.8266 14.25 13.125C14.25 13.4234 14.1315 13.7095 13.9205 13.9205C13.7095 14.1315 13.4234 14.25 13.125 14.25H10.5C10.3011 14.25 10.1103 14.329 9.96967 14.4697C9.82902 14.6103 9.75 14.8011 9.75 15C9.75 15.1989 9.82902 15.3897 9.96967 15.5303C10.1103 15.671 10.3011 15.75 10.5 15.75H13.5C13.5565 15.7498 13.6127 15.7436 13.6678 15.7313L19.9491 14.2866L19.9781 14.2791C20.1699 14.2258 20.3745 14.2454 20.5527 14.334C20.7309 14.4226 20.87 14.5739 20.9433 14.7589C21.0167 14.9439 21.0189 15.1495 20.9498 15.3361C20.8806 15.5227 20.7449 15.6771 20.5687 15.7697H20.5716ZM15.375 9C15.5603 9.00021 15.7453 8.98516 15.9281 8.955C16.1338 9.56582 16.51 10.105 17.0124 10.5088C17.5147 10.9125 18.1222 11.164 18.763 11.2335C19.4037 11.3029 20.051 11.1875 20.6282 10.9008C21.2054 10.614 21.6884 10.168 22.0202 9.61547C22.352 9.06291 22.5186 8.42691 22.5004 7.78266C22.4821 7.1384 22.2798 6.51284 21.9173 5.97993C21.5548 5.44703 21.0473 5.02905 20.4548 4.77543C19.8623 4.52181 19.2096 4.44315 18.5737 4.54875C18.3757 3.96023 18.0192 3.43775 17.5434 3.03879C17.0676 2.63984 16.4909 2.37988 15.8769 2.28754C15.2629 2.19519 14.6353 2.27403 14.0631 2.51537C13.491 2.75672 12.9966 3.15123 12.6342 3.65547C12.2719 4.15971 12.0556 4.75414 12.0093 5.37335C11.963 5.99256 12.0885 6.61254 12.3718 7.16506C12.6552 7.71759 13.0854 8.18123 13.6153 8.50497C14.1452 8.82872 14.7541 9.00001 15.375 9ZM21 7.875C21 8.24584 20.89 8.60835 20.684 8.9167C20.478 9.22504 20.1851 9.46536 19.8425 9.60728C19.4999 9.74919 19.1229 9.78632 18.7592 9.71397C18.3955 9.64163 18.0614 9.46305 17.7992 9.20083C17.537 8.9386 17.3584 8.60451 17.286 8.2408C17.2137 7.87708 17.2508 7.50008 17.3927 7.15747C17.5346 6.81486 17.775 6.52202 18.0833 6.316C18.3916 6.10997 18.7542 6 19.125 6C19.6223 6 20.0992 6.19755 20.4508 6.54918C20.8025 6.90081 21 7.37772 21 7.875ZM15.375 3.75C15.784 3.75021 16.1818 3.88416 16.5076 4.13145C16.8334 4.37874 17.0695 4.72579 17.1797 5.11969C16.7956 5.38997 16.4721 5.73744 16.2299 6.13989C15.9878 6.54234 15.8323 6.9909 15.7734 7.45688C15.6425 7.48515 15.509 7.49961 15.375 7.5C14.8777 7.5 14.4008 7.30246 14.0492 6.95083C13.6975 6.5992 13.5 6.12228 13.5 5.625C13.5 5.12772 13.6975 4.65081 14.0492 4.29918C14.4008 3.94755 14.8777 3.75 15.375 3.75Z"
                            fill="#575757"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_17818_10489">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      <span className="hide-menu">Active Loans</span>
                    </NavLink>
                  </li>
                  <li
                    className={this.isActive("/notifications")}
                    // onClick={() => this.handleChangeTab("notifications")}
                  >
                    <NavLink
                      className="waves-effect waves-dark"
                      to={`/notifications`}
                    >
                      <div>
                        {/* <span className="badge bg-danger text-white rounded">
                          {notificationLoans.length}
                        </span> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M20.7946 16.4944C20.2743 15.5981 19.5009 13.0622 19.5009 9.75C19.5009 7.76088 18.7107 5.85322 17.3042 4.4467C15.8976 3.04018 13.99 2.25 12.0009 2.25C10.0117 2.25 8.10409 3.04018 6.69757 4.4467C5.29104 5.85322 4.50087 7.76088 4.50087 9.75C4.50087 13.0631 3.72649 15.5981 3.20618 16.4944C3.07331 16.7222 3.00287 16.9811 3.00196 17.2449C3.00106 17.5086 3.06972 17.768 3.20102 17.9967C3.33233 18.2255 3.52163 18.4156 3.74984 18.5478C3.97805 18.6801 4.2371 18.7498 4.50087 18.75H8.3268C8.49984 19.5967 8.96001 20.3577 9.62949 20.9042C10.299 21.4507 11.1367 21.7492 12.0009 21.7492C12.8651 21.7492 13.7028 21.4507 14.3722 20.9042C15.0417 20.3577 15.5019 19.5967 15.6749 18.75H19.5009C19.7646 18.7496 20.0235 18.6798 20.2516 18.5475C20.4796 18.4151 20.6688 18.225 20.8 17.9963C20.9312 17.7676 20.9998 17.5083 20.9988 17.2446C20.9979 16.9809 20.9274 16.7222 20.7946 16.4944ZM12.0009 20.25C11.5357 20.2499 11.082 20.1055 10.7022 19.8369C10.3225 19.5683 10.0353 19.1886 9.88024 18.75H14.1215C13.9664 19.1886 13.6793 19.5683 13.2995 19.8369C12.9197 20.1055 12.466 20.2499 12.0009 20.25ZM4.50087 17.25C5.22274 16.0087 6.00087 13.1325 6.00087 9.75C6.00087 8.1587 6.63301 6.63258 7.75823 5.50736C8.88344 4.38214 10.4096 3.75 12.0009 3.75C13.5922 3.75 15.1183 4.38214 16.2435 5.50736C17.3687 6.63258 18.0009 8.1587 18.0009 9.75C18.0009 13.1297 18.7771 16.0059 19.5009 17.25H4.50087Z"
                            fill="#575757"
                          />
                        </svg>
                        <span className="hide-menu">Notifications</span>
                      </div>
                    </NavLink>
                  </li>
                  <li
                    className={this.isActive("/predictive-call")}
                    // onClick={() => this.handleChangeTab("predictive-call")}
                  >
                    {" "}
                    <NavLink
                      className="waves-effect waves-dark"
                      to={`/predictive-call`}
                      activeClassName="my-custom-active-class"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M14.2753 3.55575C14.3008 3.46056 14.3447 3.37133 14.4047 3.29315C14.4647 3.21496 14.5394 3.14935 14.6247 3.10008C14.7101 3.0508 14.8043 3.01882 14.9019 3.00596C14.9996 2.99309 15.0989 2.99961 15.1941 3.02512C16.5844 3.38789 17.853 4.11473 18.869 5.13078C19.8851 6.14684 20.6119 7.41538 20.9747 8.80575C21.0002 8.90092 21.0067 9.00018 20.9939 9.09786C20.981 9.19555 20.949 9.28974 20.8997 9.37506C20.8505 9.46039 20.7849 9.53516 20.7067 9.59512C20.6285 9.65508 20.5392 9.69904 20.4441 9.7245C20.3807 9.74114 20.3155 9.74964 20.25 9.74981C20.0847 9.74981 19.9241 9.69521 19.793 9.59451C19.662 9.4938 19.5679 9.35263 19.5253 9.19293C19.2295 8.05792 18.6362 7.02235 17.8069 6.19296C16.9775 5.36356 15.9419 4.77036 14.8069 4.4745C14.7116 4.44914 14.6223 4.40525 14.544 4.34533C14.4657 4.28542 14.4 4.21066 14.3506 4.12533C14.3012 4.04 14.2692 3.94577 14.2563 3.84803C14.2433 3.7503 14.2498 3.65098 14.2753 3.55575ZM14.0569 7.4745C15.3497 7.8195 16.1803 8.65012 16.5253 9.94293C16.5679 10.1026 16.662 10.2438 16.793 10.3445C16.9241 10.4452 17.0847 10.4998 17.25 10.4998C17.3155 10.4996 17.3807 10.4911 17.4441 10.4745C17.5392 10.449 17.6285 10.4051 17.7067 10.3451C17.7849 10.2852 17.8505 10.2104 17.8997 10.1251C17.949 10.0397 17.981 9.94555 17.9939 9.84786C18.0067 9.75018 18.0002 9.65092 17.9747 9.55575C17.4947 7.7595 16.2403 6.50512 14.4441 6.02512C14.3489 5.9997 14.2497 5.99327 14.152 6.0062C14.0543 6.01913 13.9602 6.05117 13.8749 6.10049C13.7897 6.1498 13.7149 6.21543 13.655 6.29363C13.5951 6.37182 13.5512 6.46105 13.5258 6.55622C13.5004 6.65138 13.4939 6.75063 13.5069 6.84828C13.5198 6.94593 13.5518 7.04008 13.6011 7.12535C13.6505 7.21062 13.7161 7.28534 13.7943 7.34525C13.8725 7.40516 13.9617 7.44907 14.0569 7.4745ZM21.7388 16.4136C21.5716 17.6839 20.9477 18.85 19.9837 19.6939C19.0196 20.5379 17.7813 21.0021 16.5 20.9998C9.05625 20.9998 3 14.9436 3 7.49981C2.9977 6.21852 3.4619 4.98021 4.30588 4.01615C5.14986 3.05209 6.31591 2.42822 7.58625 2.26106C7.90749 2.22184 8.2328 2.28756 8.51361 2.44841C8.79443 2.60926 9.01569 2.85662 9.14438 3.15356L11.1244 7.57387V7.58512C11.2229 7.81242 11.2636 8.06059 11.2428 8.30744C11.222 8.5543 11.1404 8.79217 11.0053 8.99981C10.9884 9.02512 10.9706 9.04856 10.9519 9.072L9 11.3857C9.70219 12.8126 11.1947 14.292 12.6403 14.9961L14.9222 13.0545C14.9446 13.0357 14.9681 13.0181 14.9925 13.002C15.2 12.8636 15.4387 12.7792 15.687 12.7562C15.9353 12.7333 16.1854 12.7727 16.4147 12.8707L16.4269 12.8764L20.8434 14.8554C21.1409 14.9837 21.3889 15.2047 21.5502 15.4856C21.7116 15.7664 21.7778 16.092 21.7388 16.4136ZM20.25 16.2261C20.25 16.2261 20.2434 16.2261 20.2397 16.2261L15.8334 14.2526L13.5506 16.1942C13.5285 16.2129 13.5053 16.2305 13.4813 16.2467C13.2654 16.3907 13.0159 16.4762 12.7571 16.495C12.4983 16.5137 12.239 16.465 12.0047 16.3536C10.2488 15.5051 8.49844 13.7679 7.64906 12.0307C7.53659 11.7981 7.48612 11.5404 7.50255 11.2825C7.51897 11.0246 7.60173 10.7754 7.74281 10.5589C7.75872 10.5335 7.77658 10.5093 7.79625 10.4867L9.75 8.17012L7.78125 3.76387C7.78088 3.76013 7.78088 3.75636 7.78125 3.75262C6.87211 3.87122 6.03739 4.31715 5.43339 5.00692C4.82939 5.69669 4.49754 6.58297 4.5 7.49981C4.50347 10.6813 5.76887 13.7316 8.01856 15.9813C10.2682 18.2309 13.3185 19.4963 16.5 19.4998C17.4163 19.503 18.3023 19.1723 18.9925 18.5696C19.6827 17.9669 20.1297 17.1335 20.25 16.2251V16.2261Z"
                          fill="#575757"
                        />
                      </svg>
                      <span className="hide-menu">Predictive Call</span>
                    </NavLink>
                  </li>
                </React.Fragment>
              )}

              {role === Role.CRM_MANAGER && (
                <li className={this.isActive("/target-settings")}>
                  {" "}
                  <NavLink
                    className="waves-effect waves-dark"
                    to={`/target-settings`}
                  >
                    <i className="fa fa-users" />
                    <span
                      className="hide-menu"
                      onClick={() => this.handleChangeTab("target-setting")}
                    >
                      Target Settings
                    </span>
                  </NavLink>
                </li>
              )}

              {role === Role.CRM_MANAGER && (
                <React.Fragment>
                  <li className={this.isActive("/loans")}>
                    {" "}
                    <NavLink
                      className="waves-effect waves-dark"
                      to={`/loans`}
                      onClick={this.reloadPage}
                      activeClassName="my-custom-active-class"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_17818_10489)">
                          <path
                            d="M21.5934 13.2244C21.3144 13.0096 20.9895 12.8622 20.6442 12.7934C20.2988 12.7246 19.9422 12.7364 19.6022 12.8278L15.6797 13.7297C15.7709 13.3442 15.7738 12.943 15.6879 12.5563C15.6021 12.1695 15.4298 11.8072 15.1841 11.4965C14.9383 11.1858 14.6254 10.9347 14.2688 10.7622C13.9122 10.5896 13.5212 10.5 13.125 10.5H8.43188C8.03775 10.499 7.64733 10.5761 7.28319 10.7269C6.91904 10.8777 6.58838 11.0991 6.31031 11.3784L4.18969 13.5H1.5C1.10218 13.5 0.720644 13.658 0.43934 13.9393C0.158035 14.2206 0 14.6022 0 15L0 18.75C0 19.1478 0.158035 19.5294 0.43934 19.8107C0.720644 20.092 1.10218 20.25 1.5 20.25H11.25C11.3113 20.25 11.3724 20.2425 11.4319 20.2275L17.4319 18.7275C17.4701 18.7184 17.5075 18.7058 17.5434 18.69L21.1875 17.1394L21.2288 17.1206C21.579 16.9456 21.8789 16.6843 22.1002 16.3614C22.3215 16.0385 22.457 15.6645 22.4939 15.2747C22.5307 14.8849 22.4678 14.4922 22.3109 14.1335C22.154 13.7748 21.9084 13.4619 21.5972 13.2244H21.5934ZM1.5 15H3.75V18.75H1.5V15ZM20.5716 15.7697L17.0091 17.2866L11.1562 18.75H5.25V14.5603L7.37156 12.4397C7.51035 12.2998 7.67555 12.1889 7.85758 12.1134C8.03961 12.0379 8.23482 11.9994 8.43188 12H13.125C13.4234 12 13.7095 12.1185 13.9205 12.3295C14.1315 12.5405 14.25 12.8266 14.25 13.125C14.25 13.4234 14.1315 13.7095 13.9205 13.9205C13.7095 14.1315 13.4234 14.25 13.125 14.25H10.5C10.3011 14.25 10.1103 14.329 9.96967 14.4697C9.82902 14.6103 9.75 14.8011 9.75 15C9.75 15.1989 9.82902 15.3897 9.96967 15.5303C10.1103 15.671 10.3011 15.75 10.5 15.75H13.5C13.5565 15.7498 13.6127 15.7436 13.6678 15.7313L19.9491 14.2866L19.9781 14.2791C20.1699 14.2258 20.3745 14.2454 20.5527 14.334C20.7309 14.4226 20.87 14.5739 20.9433 14.7589C21.0167 14.9439 21.0189 15.1495 20.9498 15.3361C20.8806 15.5227 20.7449 15.6771 20.5687 15.7697H20.5716ZM15.375 9C15.5603 9.00021 15.7453 8.98516 15.9281 8.955C16.1338 9.56582 16.51 10.105 17.0124 10.5088C17.5147 10.9125 18.1222 11.164 18.763 11.2335C19.4037 11.3029 20.051 11.1875 20.6282 10.9008C21.2054 10.614 21.6884 10.168 22.0202 9.61547C22.352 9.06291 22.5186 8.42691 22.5004 7.78266C22.4821 7.1384 22.2798 6.51284 21.9173 5.97993C21.5548 5.44703 21.0473 5.02905 20.4548 4.77543C19.8623 4.52181 19.2096 4.44315 18.5737 4.54875C18.3757 3.96023 18.0192 3.43775 17.5434 3.03879C17.0676 2.63984 16.4909 2.37988 15.8769 2.28754C15.2629 2.19519 14.6353 2.27403 14.0631 2.51537C13.491 2.75672 12.9966 3.15123 12.6342 3.65547C12.2719 4.15971 12.0556 4.75414 12.0093 5.37335C11.963 5.99256 12.0885 6.61254 12.3718 7.16506C12.6552 7.71759 13.0854 8.18123 13.6153 8.50497C14.1452 8.82872 14.7541 9.00001 15.375 9ZM21 7.875C21 8.24584 20.89 8.60835 20.684 8.9167C20.478 9.22504 20.1851 9.46536 19.8425 9.60728C19.4999 9.74919 19.1229 9.78632 18.7592 9.71397C18.3955 9.64163 18.0614 9.46305 17.7992 9.20083C17.537 8.9386 17.3584 8.60451 17.286 8.2408C17.2137 7.87708 17.2508 7.50008 17.3927 7.15747C17.5346 6.81486 17.775 6.52202 18.0833 6.316C18.3916 6.10997 18.7542 6 19.125 6C19.6223 6 20.0992 6.19755 20.4508 6.54918C20.8025 6.90081 21 7.37772 21 7.875ZM15.375 3.75C15.784 3.75021 16.1818 3.88416 16.5076 4.13145C16.8334 4.37874 17.0695 4.72579 17.1797 5.11969C16.7956 5.38997 16.4721 5.73744 16.2299 6.13989C15.9878 6.54234 15.8323 6.9909 15.7734 7.45688C15.6425 7.48515 15.509 7.49961 15.375 7.5C14.8777 7.5 14.4008 7.30246 14.0492 6.95083C13.6975 6.5992 13.5 6.12228 13.5 5.625C13.5 5.12772 13.6975 4.65081 14.0492 4.29918C14.4008 3.94755 14.8777 3.75 15.375 3.75Z"
                            fill="#575757"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_17818_10489">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      <span
                        className="hide-menu"
                        onClick={() => this.handleChangeTab("loans")}
                      >
                        Loans
                      </span>
                    </NavLink>
                  </li>
                  <li className={this.isActive("/loans/auto-allocation")}>
                    <NavLink
                      className="waves-effect waves-dark"
                      to={`/loans/auto-allocation`}
                      onClick={this.reloadPage}
                      activeClassName="my-custom-active-class"
                    >
                      <div className="icon-wrapper">
                        <img
                          src={processallocation}
                          alt="Process Allocation Icon"
                          className="icon"
                        />
                        <span className="hide-menu">Auto Loan allocation</span>
                      </div>
                    </NavLink>
                  </li>
                  {/* <li> <NavLink className="waves-effect waves-dark" to={`/active-loans`} ><i className="ti-layout-column3-alt" /><span className="hide-menu">Active Loans</span></NavLink>
                                        </li> */}
                  <li className={this.isActive("/Reconciliation")}>
                    {" "}
                    <NavLink
                      className="waves-effect waves-dark"
                      to={`/Reconciliation`}
                      onClick={this.reloadPage}
                      activeClassName="my-custom-active-class"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M11.227 20.4316C11.1865 20.5939 11.0928 20.7379 10.961 20.8408C10.8292 20.9438 10.6668 20.9997 10.4995 20.9997C10.4363 21 10.3734 20.9925 10.312 20.9772L7.31202 20.2272C7.2285 20.2063 7.14922 20.1711 7.07765 20.1232L4.82765 18.6232C4.66218 18.5128 4.54734 18.3412 4.5084 18.1461C4.46945 17.951 4.5096 17.7485 4.61999 17.583C4.73039 17.4175 4.902 17.3027 5.09706 17.2638C5.29213 17.2248 5.49468 17.265 5.66015 17.3754L7.8014 18.8032L10.6758 19.5222C10.7718 19.5455 10.8623 19.5876 10.942 19.6459C11.0218 19.7043 11.0892 19.7778 11.1404 19.8623C11.1917 19.9468 11.2257 20.0406 11.2405 20.1383C11.2554 20.236 11.2508 20.3357 11.227 20.4316ZM23.6667 11.3885C23.6052 11.5754 23.5072 11.7483 23.3785 11.8971C23.2498 12.046 23.0928 12.1678 22.9167 12.2557L20.6967 13.3657L15.533 18.5304C15.4413 18.6219 15.3275 18.6882 15.2027 18.7227C15.0778 18.7572 14.9461 18.7587 14.8205 18.7272L8.82046 17.2272C8.72922 17.2043 8.64305 17.1646 8.5664 17.11L3.3614 13.3938L1.08515 12.2557C0.729402 12.0778 0.458845 11.766 0.332968 11.3887C0.207092 11.0114 0.236203 10.5996 0.4139 10.2438L2.74359 5.58536C2.92142 5.22961 3.23327 4.95906 3.61054 4.83318C3.98782 4.7073 4.39964 4.73642 4.75546 4.91411L6.82359 5.94536L11.7923 4.52599C11.9271 4.48743 12.07 4.48743 12.2048 4.52599L17.1736 5.94536L19.2417 4.91411C19.5975 4.73642 20.0094 4.7073 20.3866 4.83318C20.7639 4.95906 21.0758 5.22961 21.2536 5.58536L23.5833 10.2438C23.6721 10.4196 23.7253 10.6113 23.7396 10.8078C23.7539 11.0043 23.7291 11.2016 23.6667 11.3885ZM19.3373 12.6016L16.7864 7.49974H13.8033L9.74953 11.4372C10.9364 12.1957 12.7973 12.4047 14.467 10.7219C14.5974 10.5905 14.7718 10.5119 14.9567 10.5014C15.1415 10.4908 15.3238 10.549 15.4683 10.6647L18.6942 13.2494L19.3373 12.6016ZM1.75546 10.9141L3.4139 11.7438L5.74359 7.08536L4.08515 6.25567L1.75546 10.9141ZM17.6245 14.3116L15.0267 12.2313C13.1948 13.7313 10.8689 13.9291 8.9414 12.7C8.7518 12.5794 8.59171 12.4178 8.47298 12.227C8.35424 12.0362 8.27989 11.8212 8.25541 11.5978C8.23093 11.3744 8.25695 11.1484 8.33155 10.9365C8.40615 10.7245 8.52742 10.532 8.6864 10.3732C8.68866 10.3704 8.69117 10.3679 8.6939 10.3657L12.8995 6.28661L11.9995 6.02974L7.27265 7.38067L4.70671 12.5116L9.31921 15.8069L14.7698 17.1691L17.6245 14.3116ZM22.2408 10.9141L19.9139 6.25567L18.2555 7.08536L20.5851 11.7438L22.2408 10.9141Z"
                          fill="#575757"
                        />
                      </svg>
                      <span
                        className="hide-menu"
                        onClick={() => this.handleChangeTab("reconciliation")}
                      >
                        Reconciliation
                      </span>
                    </NavLink>
                  </li>
                  {/* <li className={`manager-siderbar-link ${this.isActive("processAllocation")}`}>
                    {" "}
                    <Link
                      className="waves-effect waves-dark"
                      to={`/process-allocation`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M11.227 20.4316C11.1865 20.5939 11.0928 20.7379 10.961 20.8408C10.8292 20.9438 10.6668 20.9997 10.4995 20.9997C10.4363 21 10.3734 20.9925 10.312 20.9772L7.31202 20.2272C7.2285 20.2063 7.14922 20.1711 7.07765 20.1232L4.82765 18.6232C4.66218 18.5128 4.54734 18.3412 4.5084 18.1461C4.46945 17.951 4.5096 17.7485 4.61999 17.583C4.73039 17.4175 4.902 17.3027 5.09706 17.2638C5.29213 17.2248 5.49468 17.265 5.66015 17.3754L7.8014 18.8032L10.6758 19.5222C10.7718 19.5455 10.8623 19.5876 10.942 19.6459C11.0218 19.7043 11.0892 19.7778 11.1404 19.8623C11.1917 19.9468 11.2257 20.0406 11.2405 20.1383C11.2554 20.236 11.2508 20.3357 11.227 20.4316ZM23.6667 11.3885C23.6052 11.5754 23.5072 11.7483 23.3785 11.8971C23.2498 12.046 23.0928 12.1678 22.9167 12.2557L20.6967 13.3657L15.533 18.5304C15.4413 18.6219 15.3275 18.6882 15.2027 18.7227C15.0778 18.7572 14.9461 18.7587 14.8205 18.7272L8.82046 17.2272C8.72922 17.2043 8.64305 17.1646 8.5664 17.11L3.3614 13.3938L1.08515 12.2557C0.729402 12.0778 0.458845 11.766 0.332968 11.3887C0.207092 11.0114 0.236203 10.5996 0.4139 10.2438L2.74359 5.58536C2.92142 5.22961 3.23327 4.95906 3.61054 4.83318C3.98782 4.7073 4.39964 4.73642 4.75546 4.91411L6.82359 5.94536L11.7923 4.52599C11.9271 4.48743 12.07 4.48743 12.2048 4.52599L17.1736 5.94536L19.2417 4.91411C19.5975 4.73642 20.0094 4.7073 20.3866 4.83318C20.7639 4.95906 21.0758 5.22961 21.2536 5.58536L23.5833 10.2438C23.6721 10.4196 23.7253 10.6113 23.7396 10.8078C23.7539 11.0043 23.7291 11.2016 23.6667 11.3885ZM19.3373 12.6016L16.7864 7.49974H13.8033L9.74953 11.4372C10.9364 12.1957 12.7973 12.4047 14.467 10.7219C14.5974 10.5905 14.7718 10.5119 14.9567 10.5014C15.1415 10.4908 15.3238 10.549 15.4683 10.6647L18.6942 13.2494L19.3373 12.6016ZM1.75546 10.9141L3.4139 11.7438L5.74359 7.08536L4.08515 6.25567L1.75546 10.9141ZM17.6245 14.3116L15.0267 12.2313C13.1948 13.7313 10.8689 13.9291 8.9414 12.7C8.7518 12.5794 8.59171 12.4178 8.47298 12.227C8.35424 12.0362 8.27989 11.8212 8.25541 11.5978C8.23093 11.3744 8.25695 11.1484 8.33155 10.9365C8.40615 10.7245 8.52742 10.532 8.6864 10.3732C8.68866 10.3704 8.69117 10.3679 8.6939 10.3657L12.8995 6.28661L11.9995 6.02974L7.27265 7.38067L4.70671 12.5116L9.31921 15.8069L14.7698 17.1691L17.6245 14.3116ZM22.2408 10.9141L19.9139 6.25567L18.2555 7.08536L20.5851 11.7438L22.2408 10.9141Z"
                          fill="#575757"
                        />
                      </svg>
                      <span className={`hidemenu`} onClick={() => this.handleChangeTab("processAllocation")}>Process Allocation</span>
                    </Link> */}
                  {/* </li> */}
                  <li className={this.isActive("/notifications")}>
                    <NavLink
                      className="waves-effect waves-dark"
                      to={`/notifications`}
                    >
                      <div>
                        {/* <span className="badge bg-danger text-white rounded">
                          {notificationLoans.length}
                        </span> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M20.7946 16.4944C20.2743 15.5981 19.5009 13.0622 19.5009 9.75C19.5009 7.76088 18.7107 5.85322 17.3042 4.4467C15.8976 3.04018 13.99 2.25 12.0009 2.25C10.0117 2.25 8.10409 3.04018 6.69757 4.4467C5.29104 5.85322 4.50087 7.76088 4.50087 9.75C4.50087 13.0631 3.72649 15.5981 3.20618 16.4944C3.07331 16.7222 3.00287 16.9811 3.00196 17.2449C3.00106 17.5086 3.06972 17.768 3.20102 17.9967C3.33233 18.2255 3.52163 18.4156 3.74984 18.5478C3.97805 18.6801 4.2371 18.7498 4.50087 18.75H8.3268C8.49984 19.5967 8.96001 20.3577 9.62949 20.9042C10.299 21.4507 11.1367 21.7492 12.0009 21.7492C12.8651 21.7492 13.7028 21.4507 14.3722 20.9042C15.0417 20.3577 15.5019 19.5967 15.6749 18.75H19.5009C19.7646 18.7496 20.0235 18.6798 20.2516 18.5475C20.4796 18.4151 20.6688 18.225 20.8 17.9963C20.9312 17.7676 20.9998 17.5083 20.9988 17.2446C20.9979 16.9809 20.9274 16.7222 20.7946 16.4944ZM12.0009 20.25C11.5357 20.2499 11.082 20.1055 10.7022 19.8369C10.3225 19.5683 10.0353 19.1886 9.88024 18.75H14.1215C13.9664 19.1886 13.6793 19.5683 13.2995 19.8369C12.9197 20.1055 12.466 20.2499 12.0009 20.25ZM4.50087 17.25C5.22274 16.0087 6.00087 13.1325 6.00087 9.75C6.00087 8.1587 6.63301 6.63258 7.75823 5.50736C8.88344 4.38214 10.4096 3.75 12.0009 3.75C13.5922 3.75 15.1183 4.38214 16.2435 5.50736C17.3687 6.63258 18.0009 8.1587 18.0009 9.75C18.0009 13.1297 18.7771 16.0059 19.5009 17.25H4.50087Z"
                            fill="#575757"
                          />
                        </svg>
                        <span
                          className="hide-menu"
                          onClick={() => this.handleChangeTab("notifications")}
                        >
                          Notifications
                        </span>
                      </div>
                    </NavLink>
                  </li>
                  <li className={this.isActive("/agent-monitor")}>
                    <NavLink
                      className="waves-effect waves-dark"
                      to={`/agent-monitor`}
                      onClick={this.reloadPage}
                    >
                      <div>
                        {/* <span className="badge bg-danger text-white rounded">
                          {notificationCount}
                        </span> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="30"
                          viewBox="0 0 36 36"
                          fill="none"
                        >
                          <path
                            d="M27.8618 27.4005C27.9998 27.5646 28.088 27.7646 28.1162 27.9772C28.1443 28.1897 28.1111 28.4058 28.0205 28.6001C27.93 28.7944 27.7858 28.9588 27.6049 29.0739C27.4241 29.1889 27.2141 29.25 26.9997 29.2498H3.37474C3.16049 29.2497 2.95071 29.1885 2.77007 29.0733C2.58943 28.9581 2.44545 28.7937 2.35505 28.5994C2.26465 28.4052 2.2316 28.1892 2.25977 27.9768C2.28795 27.7644 2.37619 27.5645 2.51411 27.4005C4.61505 24.9002 7.22786 23.1241 10.1318 22.1735C8.36819 21.0751 7.01034 19.4322 6.26364 17.4933C5.51694 15.5545 5.42202 13.4252 5.99324 11.4276C6.56446 9.42999 7.77074 7.67278 9.42958 6.4218C11.0884 5.17082 13.1096 4.49414 15.1872 4.49414C17.2649 4.49414 19.2861 5.17082 20.9449 6.4218C22.6037 7.67278 23.81 9.42999 24.3812 11.4276C24.9525 13.4252 24.8575 15.5545 24.1108 17.4933C23.3641 19.4322 22.0063 21.0751 20.2427 22.1735C23.1466 23.1241 25.7594 24.9002 27.8618 27.4005ZM34.7594 21.656C34.6605 21.8273 34.5183 21.9695 34.3469 22.0682C34.1756 22.167 33.9813 22.2188 33.7835 22.2185C33.586 22.2191 33.3918 22.1672 33.221 22.068L32.5643 21.6884C32.25 21.958 31.8886 22.1673 31.4983 22.3057V23.0623C31.4983 23.3606 31.3798 23.6468 31.1688 23.8578C30.9578 24.0687 30.6717 24.1873 30.3733 24.1873C30.075 24.1873 29.7888 24.0687 29.5778 23.8578C29.3669 23.6468 29.2483 23.3606 29.2483 23.0623V22.3057C28.858 22.1673 28.4967 21.958 28.1824 21.6884L27.5257 22.068C27.3548 22.1672 27.1607 22.2191 26.9632 22.2185C26.7154 22.2186 26.4746 22.1369 26.278 21.9862C26.0815 21.8354 25.9402 21.6239 25.8761 21.3847C25.812 21.1454 25.8286 20.8916 25.9235 20.6627C26.0183 20.4339 26.1861 20.2428 26.4007 20.119L27.056 19.7407C26.9791 19.3337 26.9791 18.9159 27.056 18.5088L26.4007 18.1305C26.2727 18.0567 26.1605 17.9583 26.0706 17.8411C25.9806 17.7239 25.9146 17.5901 25.8763 17.4474C25.8381 17.3046 25.8283 17.1558 25.8476 17.0093C25.8668 16.8628 25.9148 16.7215 25.9886 16.5935C26.0625 16.4655 26.1609 16.3534 26.2781 16.2634C26.3953 16.1734 26.5291 16.1074 26.6718 16.0692C26.8146 16.0309 26.9634 16.0211 27.1099 16.0404C27.2564 16.0597 27.3977 16.1076 27.5257 16.1815L28.1824 16.5612C28.4967 16.2915 28.858 16.0822 29.2483 15.9438V15.1873C29.2483 14.8889 29.3669 14.6027 29.5778 14.3918C29.7888 14.1808 30.075 14.0623 30.3733 14.0623C30.6717 14.0623 30.9578 14.1808 31.1688 14.3918C31.3798 14.6027 31.4983 14.8889 31.4983 15.1873V15.9438C31.8886 16.0822 32.25 16.2915 32.5643 16.5612L33.221 16.1815C33.349 16.1076 33.4902 16.0597 33.6367 16.0404C33.7832 16.0211 33.9321 16.0309 34.0748 16.0692C34.2176 16.1074 34.3514 16.1734 34.4686 16.2634C34.5858 16.3534 34.6842 16.4655 34.758 16.5935C34.8319 16.7215 34.8798 16.8628 34.8991 17.0093C34.9184 17.1558 34.9086 17.3046 34.8703 17.4474C34.8321 17.5901 34.7661 17.7239 34.6761 17.8411C34.5861 17.9583 34.474 18.0567 34.346 18.1305L33.6907 18.5088C33.7676 18.9159 33.7676 19.3337 33.6907 19.7407L34.346 20.119C34.4741 20.1927 34.5864 20.291 34.6766 20.4081C34.7667 20.5253 34.8328 20.6591 34.8712 20.8018C34.9096 20.9446 34.9195 21.0935 34.9003 21.24C34.8811 21.3866 34.8333 21.528 34.7594 21.656ZM30.3747 20.2498C30.5972 20.2498 30.8148 20.1838 30.9998 20.0602C31.1848 19.9366 31.329 19.7608 31.4141 19.5553C31.4993 19.3497 31.5215 19.1235 31.4781 18.9053C31.4347 18.6871 31.3276 18.4866 31.1702 18.3293C31.0129 18.1719 30.8124 18.0648 30.5942 18.0214C30.376 17.978 30.1498 18.0003 29.9442 18.0854C29.7387 18.1705 29.563 18.3147 29.4393 18.4997C29.3157 18.6848 29.2497 18.9023 29.2497 19.1248C29.2497 19.4231 29.3683 19.7093 29.5792 19.9203C29.7902 20.1312 30.0764 20.2498 30.3747 20.2498Z"
                            fill="#575757"
                          />
                        </svg>
                        <span
                          className="hide-menu"
                          onClick={() => this.handleChangeTab("agentMonitor")}
                        >
                          Agent Monitor
                        </span>
                      </div>
                    </NavLink>
                  </li>

                  {/* <li className={this.isActive("/target-settings")}>
                    {" "}
                    <NavLink
                      className="waves-effect waves-dark"
                      to={`/target-settings`}
                    >
                      <i className="fa fa-users" />
                      <span
                        className="hide-menu"
                        onClick={() => this.handleChangeTab("target-setting")}
                      >
                        Target Settings
                      </span>
                    </NavLink>
                  </li> */}
                </React.Fragment>
              )}

              {role === Role.CRM_SUPERMANAGER && (
                <li className={this.isActive("/notifications")}>
                  <NavLink
                    className="waves-effect waves-dark"
                    to={`/notifications`}
                  >
                    <div>
                      {/* <span className="badge bg-danger text-white rounded">
                      {notificationLoans.length}
                    </span> */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M20.7946 16.4944C20.2743 15.5981 19.5009 13.0622 19.5009 9.75C19.5009 7.76088 18.7107 5.85322 17.3042 4.4467C15.8976 3.04018 13.99 2.25 12.0009 2.25C10.0117 2.25 8.10409 3.04018 6.69757 4.4467C5.29104 5.85322 4.50087 7.76088 4.50087 9.75C4.50087 13.0631 3.72649 15.5981 3.20618 16.4944C3.07331 16.7222 3.00287 16.9811 3.00196 17.2449C3.00106 17.5086 3.06972 17.768 3.20102 17.9967C3.33233 18.2255 3.52163 18.4156 3.74984 18.5478C3.97805 18.6801 4.2371 18.7498 4.50087 18.75H8.3268C8.49984 19.5967 8.96001 20.3577 9.62949 20.9042C10.299 21.4507 11.1367 21.7492 12.0009 21.7492C12.8651 21.7492 13.7028 21.4507 14.3722 20.9042C15.0417 20.3577 15.5019 19.5967 15.6749 18.75H19.5009C19.7646 18.7496 20.0235 18.6798 20.2516 18.5475C20.4796 18.4151 20.6688 18.225 20.8 17.9963C20.9312 17.7676 20.9998 17.5083 20.9988 17.2446C20.9979 16.9809 20.9274 16.7222 20.7946 16.4944ZM12.0009 20.25C11.5357 20.2499 11.082 20.1055 10.7022 19.8369C10.3225 19.5683 10.0353 19.1886 9.88024 18.75H14.1215C13.9664 19.1886 13.6793 19.5683 13.2995 19.8369C12.9197 20.1055 12.466 20.2499 12.0009 20.25ZM4.50087 17.25C5.22274 16.0087 6.00087 13.1325 6.00087 9.75C6.00087 8.1587 6.63301 6.63258 7.75823 5.50736C8.88344 4.38214 10.4096 3.75 12.0009 3.75C13.5922 3.75 15.1183 4.38214 16.2435 5.50736C17.3687 6.63258 18.0009 8.1587 18.0009 9.75C18.0009 13.1297 18.7771 16.0059 19.5009 17.25H4.50087Z"
                          fill="#575757"
                        />
                      </svg>
                      <span
                        className="hide-menu"
                        onClick={() => this.handleChangeTab("notifications")}
                      >
                        Notifications
                      </span>
                    </div>
                  </NavLink>
                </li>
              )}

              {collektoUser && collektoUser.role === Role.CLIENT_ADMIN && (
                <li className={this.isActive("/reconciliation")}>
                  {" "}
                  <NavLink
                    className="waves-effect waves-dark"
                    to={`/Reconciliation`}
                    onClick={this.reloadPage}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M11.227 20.4316C11.1865 20.5939 11.0928 20.7379 10.961 20.8408C10.8292 20.9438 10.6668 20.9997 10.4995 20.9997C10.4363 21 10.3734 20.9925 10.312 20.9772L7.31202 20.2272C7.2285 20.2063 7.14922 20.1711 7.07765 20.1232L4.82765 18.6232C4.66218 18.5128 4.54734 18.3412 4.5084 18.1461C4.46945 17.951 4.5096 17.7485 4.61999 17.583C4.73039 17.4175 4.902 17.3027 5.09706 17.2638C5.29213 17.2248 5.49468 17.265 5.66015 17.3754L7.8014 18.8032L10.6758 19.5222C10.7718 19.5455 10.8623 19.5876 10.942 19.6459C11.0218 19.7043 11.0892 19.7778 11.1404 19.8623C11.1917 19.9468 11.2257 20.0406 11.2405 20.1383C11.2554 20.236 11.2508 20.3357 11.227 20.4316ZM23.6667 11.3885C23.6052 11.5754 23.5072 11.7483 23.3785 11.8971C23.2498 12.046 23.0928 12.1678 22.9167 12.2557L20.6967 13.3657L15.533 18.5304C15.4413 18.6219 15.3275 18.6882 15.2027 18.7227C15.0778 18.7572 14.9461 18.7587 14.8205 18.7272L8.82046 17.2272C8.72922 17.2043 8.64305 17.1646 8.5664 17.11L3.3614 13.3938L1.08515 12.2557C0.729402 12.0778 0.458845 11.766 0.332968 11.3887C0.207092 11.0114 0.236203 10.5996 0.4139 10.2438L2.74359 5.58536C2.92142 5.22961 3.23327 4.95906 3.61054 4.83318C3.98782 4.7073 4.39964 4.73642 4.75546 4.91411L6.82359 5.94536L11.7923 4.52599C11.9271 4.48743 12.07 4.48743 12.2048 4.52599L17.1736 5.94536L19.2417 4.91411C19.5975 4.73642 20.0094 4.7073 20.3866 4.83318C20.7639 4.95906 21.0758 5.22961 21.2536 5.58536L23.5833 10.2438C23.6721 10.4196 23.7253 10.6113 23.7396 10.8078C23.7539 11.0043 23.7291 11.2016 23.6667 11.3885ZM19.3373 12.6016L16.7864 7.49974H13.8033L9.74953 11.4372C10.9364 12.1957 12.7973 12.4047 14.467 10.7219C14.5974 10.5905 14.7718 10.5119 14.9567 10.5014C15.1415 10.4908 15.3238 10.549 15.4683 10.6647L18.6942 13.2494L19.3373 12.6016ZM1.75546 10.9141L3.4139 11.7438L5.74359 7.08536L4.08515 6.25567L1.75546 10.9141ZM17.6245 14.3116L15.0267 12.2313C13.1948 13.7313 10.8689 13.9291 8.9414 12.7C8.7518 12.5794 8.59171 12.4178 8.47298 12.227C8.35424 12.0362 8.27989 11.8212 8.25541 11.5978C8.23093 11.3744 8.25695 11.1484 8.33155 10.9365C8.40615 10.7245 8.52742 10.532 8.6864 10.3732C8.68866 10.3704 8.69117 10.3679 8.6939 10.3657L12.8995 6.28661L11.9995 6.02974L7.27265 7.38067L4.70671 12.5116L9.31921 15.8069L14.7698 17.1691L17.6245 14.3116ZM22.2408 10.9141L19.9139 6.25567L18.2555 7.08536L20.5851 11.7438L22.2408 10.9141Z"
                        fill="#575757"
                      />
                    </svg>
                    <span
                      className="hide-menu"
                      // onClick={() => this.handleChangeTab("reconciliation")}
                    >
                      Reconciliation
                    </span>
                  </NavLink>
                </li>
              )}
              {collektoUser && role !== Role.CRM_TELECALLER && (
                <li>
                  {" "}
                  <a
                    className={`has-arrow waves-effect ${wavesDark}`}
                    data-toggle="collapse"
                    href="#dialerReports"
                    aria-expanded="false"
                    // style={{ display: "flex" }}
                  >
                    {/* <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M20.0306 6.21938L16.2806 2.46938C16.2109 2.39975 16.1282 2.34454 16.0371 2.3069C15.9461 2.26926 15.8485 2.24992 15.75 2.25H8.25C7.85218 2.25 7.47064 2.40804 7.18934 2.68934C6.90804 2.97064 6.75 3.35218 6.75 3.75V5.25H5.25C4.85218 5.25 4.47064 5.40804 4.18934 5.68934C3.90804 5.97064 3.75 6.35218 3.75 6.75V20.25C3.75 20.6478 3.90804 21.0294 4.18934 21.3107C4.47064 21.592 4.85218 21.75 5.25 21.75H15.75C16.1478 21.75 16.5294 21.592 16.8107 21.3107C17.092 21.0294 17.25 20.6478 17.25 20.25V18.75H18.75C19.1478 18.75 19.5294 18.592 19.8107 18.3107C20.092 18.0294 20.25 17.6478 20.25 17.25V6.75C20.2501 6.65148 20.2307 6.55391 20.1931 6.46286C20.1555 6.37182 20.1003 6.28908 20.0306 6.21938ZM15.75 20.25H5.25V6.75H12.4397L15.75 10.0603V17.985C15.75 17.9906 15.75 17.9953 15.75 18C15.75 18.0047 15.75 18.0094 15.75 18.015V20.25ZM18.75 17.25H17.25V9.75C17.2501 9.65148 17.2307 9.55391 17.1931 9.46286C17.1555 9.37182 17.1003 9.28908 17.0306 9.21937L13.2806 5.46938C13.2109 5.39975 13.1282 5.34454 13.0371 5.3069C12.9461 5.26926 12.8485 5.24992 12.75 5.25H8.25V3.75H15.4397L18.75 7.06031V17.25ZM13.5 14.25C13.5 14.4489 13.421 14.6397 13.2803 14.7803C13.1397 14.921 12.9489 15 12.75 15H8.25C8.05109 15 7.86032 14.921 7.71967 14.7803C7.57902 14.6397 7.5 14.4489 7.5 14.25C7.5 14.0511 7.57902 13.8603 7.71967 13.7197C7.86032 13.579 8.05109 13.5 8.25 13.5H12.75C12.9489 13.5 13.1397 13.579 13.2803 13.7197C13.421 13.8603 13.5 14.0511 13.5 14.25ZM13.5 17.25C13.5 17.4489 13.421 17.6397 13.2803 17.7803C13.1397 17.921 12.9489 18 12.75 18H8.25C8.05109 18 7.86032 17.921 7.71967 17.7803C7.57902 17.6397 7.5 17.4489 7.5 17.25C7.5 17.0511 7.57902 16.8603 7.71967 16.7197C7.86032 16.579 8.05109 16.5 8.25 16.5H12.75C12.9489 16.5 13.1397 16.579 13.2803 16.7197C13.421 16.8603 13.5 17.0511 13.5 17.25Z"
                        fill="#575757"
                      />
                    </svg> */}
                    <div className="icon-wrapper">
                      <img
                        src={dialerreports}
                        alt="Process Allocation Icon"
                        className="icon"
                      />
                    </div>

                    <span className="hide-menu">Dialer Report</span>
                  </a>
                  <ul
                    aria-expanded="false"
                    className={`collapse ${
                      this.role === Role.CLIENT_ADMIN ? "position-relative" : ""
                    }`}
                    id="dialerReports"
                  >
                    {(this.role.name === Role.CRM_TENANTADMIN ||
                      this.role.name === Role.CRM_SUPERADMIN) && (
                      <li>
                        {" "}
                        <Link to={`/upload-sheets`}> Upload Sheets</Link>
                      </li>
                    )}
                    <li>
                      {" "}
                      <Link to={`/process-wise-report`}>Process Wise</Link>
                    </li>
                    <li>
                      {" "}
                      <Link to={`/agent-login-report`}>Agent Login</Link>
                    </li>
                    {/* <li>
                              {" "}
                              <Link to={`/predictive-report`}>
                                {" "}
                                Predictive Outbound
                              </Link>
                            </li> */}
                    <li>
                      {" "}
                      <Link to={`/agent-performance-report`}>
                        {" "}
                        Agent Performance
                      </Link>
                    </li>

                    <li>
                      {" "}
                      <Link to={`/call-recording-reports`}>Call Recording</Link>
                    </li>
                  </ul>
                </li>
              )}
              {
                <li className={`bottom-ul ${this.isActive("/daily-reports")}`}>
                  {" "}
                  <a
                    className="has-arrow waves-effect waves-dark"
                    data-toggle="collapse"
                    href="#allreports"
                    aria-expanded="false"
                    activeClassName="my-custom-active-class"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M20.0306 6.21938L16.2806 2.46938C16.2109 2.39975 16.1282 2.34454 16.0371 2.3069C15.9461 2.26926 15.8485 2.24992 15.75 2.25H8.25C7.85218 2.25 7.47064 2.40804 7.18934 2.68934C6.90804 2.97064 6.75 3.35218 6.75 3.75V5.25H5.25C4.85218 5.25 4.47064 5.40804 4.18934 5.68934C3.90804 5.97064 3.75 6.35218 3.75 6.75V20.25C3.75 20.6478 3.90804 21.0294 4.18934 21.3107C4.47064 21.592 4.85218 21.75 5.25 21.75H15.75C16.1478 21.75 16.5294 21.592 16.8107 21.3107C17.092 21.0294 17.25 20.6478 17.25 20.25V18.75H18.75C19.1478 18.75 19.5294 18.592 19.8107 18.3107C20.092 18.0294 20.25 17.6478 20.25 17.25V6.75C20.2501 6.65148 20.2307 6.55391 20.1931 6.46286C20.1555 6.37182 20.1003 6.28908 20.0306 6.21938ZM15.75 20.25H5.25V6.75H12.4397L15.75 10.0603V17.985C15.75 17.9906 15.75 17.9953 15.75 18C15.75 18.0047 15.75 18.0094 15.75 18.015V20.25ZM18.75 17.25H17.25V9.75C17.2501 9.65148 17.2307 9.55391 17.1931 9.46286C17.1555 9.37182 17.1003 9.28908 17.0306 9.21937L13.2806 5.46938C13.2109 5.39975 13.1282 5.34454 13.0371 5.3069C12.9461 5.26926 12.8485 5.24992 12.75 5.25H8.25V3.75H15.4397L18.75 7.06031V17.25ZM13.5 14.25C13.5 14.4489 13.421 14.6397 13.2803 14.7803C13.1397 14.921 12.9489 15 12.75 15H8.25C8.05109 15 7.86032 14.921 7.71967 14.7803C7.57902 14.6397 7.5 14.4489 7.5 14.25C7.5 14.0511 7.57902 13.8603 7.71967 13.7197C7.86032 13.579 8.05109 13.5 8.25 13.5H12.75C12.9489 13.5 13.1397 13.579 13.2803 13.7197C13.421 13.8603 13.5 14.0511 13.5 14.25ZM13.5 17.25C13.5 17.4489 13.421 17.6397 13.2803 17.7803C13.1397 17.921 12.9489 18 12.75 18H8.25C8.05109 18 7.86032 17.921 7.71967 17.7803C7.57902 17.6397 7.5 17.4489 7.5 17.25C7.5 17.0511 7.57902 16.8603 7.71967 16.7197C7.86032 16.579 8.05109 16.5 8.25 16.5H12.75C12.9489 16.5 13.1397 16.579 13.2803 16.7197C13.421 16.8603 13.5 17.0511 13.5 17.25Z"
                        fill="#575757"
                      />
                    </svg>
                    <span className="hide-menu">Reports</span>
                  </a>
                  <ul
                    aria-expanded="false"
                    className={`collapse position-relative`}
                    id="allreports"
                    // onClick={() => this.handleChangeTab("reports")}
                    style={{ bottom: "60px" }}
                  >
                    <li className={this.isActive("/daily-reports")}>
                      {" "}
                      <NavLink
                        to={`/daily-reports`}
                        className={this.isActive("/daily-reports")}
                      >
                        Daily Call Reports
                      </NavLink>
                    </li>

                    {collektoUser && (
                      <li>
                        {" "}
                        <NavLink to={`/best-disposition`}>
                          Best Disposition Report
                        </NavLink>
                      </li>
                    )}
                    {collektoUser && collektoUser.role === "MANAGER" && (
                      <li className={this.isActive("/pending-client-reports")}>
                        {" "}
                        <NavLink to={`/pending-client-reports`}>
                          {" "}
                          Pending Client Approval Reports
                        </NavLink>
                      </li>
                    )}
                    {collektoUser && (
                      <li className={this.isActive("/download-reports")}>
                        {" "}
                        <NavLink
                          to={`/download-reports`}
                          className={this.isActive("download-reports")}
                        >
                          {" "}
                          Settlement Reports
                        </NavLink>
                      </li>
                    )}

                    {role !== Role.CRM_TELECALLER && (
                      <li className={this.isActive("/daily-field-reports")}>
                        {" "}
                        <NavLink to={`/daily-field-reports`}>
                          Daily Field Agent Reports
                        </NavLink>
                      </li>
                    )}

                    <li className={this.isActive("/last-interaction-report")}>
                      {" "}
                      <NavLink to={`/last-interaction-report`}>
                        Last Interaction Report
                      </NavLink>
                    </li>

                    {collektoUser && collektoUser.role === "MANAGER" && (
                      <li className={this.isActive("/login-report")}>
                        <NavLink to={`/login-report`} onClick={this.reloadPage}>
                          Login Report
                        </NavLink>
                      </li>
                    )}
                    <li className={this.isActive("/retain-report")}>
                      {collektoUser &&
                        collektoUser.role !== Role.ADMIN &&
                        collektoUser.role !== Role.CLIENT_ADMIN && (
                          <NavLink to={`/retain-report`}>Retain Report</NavLink>
                        )}
                    </li>
                    <li className={this.isActive("/allocation-reports")}>
                      {" "}
                      <NavLink to={`/allocation-reports`}>
                        Allocation Reports
                      </NavLink>
                    </li>
                    <li className={this.isActive("/additional-reports")}>
                      {" "}
                      <NavLink to={`/additional-reports`}>BOI Reports</NavLink>
                    </li>
                  </ul>
                </li>
              }

              {collektoUser && collektoUser.role === "ADMIN" && (
                <li className={this.isActive("others")}>
                  {" "}
                  <a
                    className="has-arrow waves-effect waves-dark"
                    data-toggle="collapse"
                    href="#loans"
                    aria-expanded="false"
                    activeClassName="my-custom-active-class"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M7.5 3.75C6.75832 3.75 6.0333 3.96994 5.41661 4.38199C4.79993 4.79405 4.31928 5.37972 4.03545 6.06494C3.75162 6.75016 3.67736 7.50416 3.82205 8.23159C3.96675 8.95902 4.3239 9.6272 4.84835 10.1517C5.3728 10.6761 6.04098 11.0333 6.76841 11.1779C7.49584 11.3226 8.24984 11.2484 8.93506 10.9646C9.62029 10.6807 10.206 10.2001 10.618 9.58339C11.0301 8.96671 11.25 8.24168 11.25 7.5C11.25 6.50544 10.8549 5.55161 10.1516 4.84835C9.44839 4.14509 8.49456 3.75 7.5 3.75ZM7.5 9.75C7.05499 9.75 6.61998 9.61804 6.24997 9.37081C5.87996 9.12358 5.59157 8.77217 5.42127 8.36104C5.25097 7.94991 5.20642 7.49751 5.29323 7.06105C5.38005 6.62459 5.59434 6.22368 5.90901 5.90901C6.22368 5.59434 6.62459 5.38005 7.06105 5.29323C7.4975 5.20642 7.9499 5.25098 8.36104 5.42127C8.77217 5.59157 9.12357 5.87996 9.37081 6.24997C9.61804 6.61998 9.75 7.05499 9.75 7.5C9.75 8.09674 9.51295 8.66904 9.09099 9.09099C8.66903 9.51295 8.09674 9.75 7.5 9.75ZM16.5 11.25C17.2417 11.25 17.9667 11.0301 18.5834 10.618C19.2001 10.206 19.6807 9.62029 19.9645 8.93506C20.2484 8.24984 20.3226 7.49584 20.1779 6.76841C20.0333 6.04098 19.6761 5.3728 19.1516 4.84835C18.6272 4.3239 17.959 3.96675 17.2316 3.82206C16.5042 3.67736 15.7502 3.75162 15.0649 4.03545C14.3797 4.31928 13.794 4.79993 13.382 5.41661C12.9699 6.0333 12.75 6.75832 12.75 7.5C12.75 8.49456 13.1451 9.44839 13.8483 10.1517C14.5516 10.8549 15.5054 11.25 16.5 11.25ZM16.5 5.25C16.945 5.25 17.38 5.38196 17.75 5.6292C18.12 5.87643 18.4084 6.22783 18.5787 6.63896C18.749 7.0501 18.7936 7.5025 18.7068 7.93895C18.62 8.37541 18.4057 8.77632 18.091 9.09099C17.7763 9.40566 17.3754 9.61995 16.939 9.70677C16.5025 9.79359 16.0501 9.74903 15.639 9.57873C15.2278 9.40843 14.8764 9.12005 14.6292 8.75003C14.382 8.38002 14.25 7.94501 14.25 7.5C14.25 6.90326 14.4871 6.33097 14.909 5.90901C15.331 5.48705 15.9033 5.25 16.5 5.25ZM7.5 12.75C6.75832 12.75 6.0333 12.9699 5.41661 13.382C4.79993 13.794 4.31928 14.3797 4.03545 15.0649C3.75162 15.7502 3.67736 16.5042 3.82205 17.2316C3.96675 17.959 4.3239 18.6272 4.84835 19.1517C5.3728 19.6761 6.04098 20.0333 6.76841 20.1779C7.49584 20.3226 8.24984 20.2484 8.93506 19.9646C9.62029 19.6807 10.206 19.2001 10.618 18.5834C11.0301 17.9667 11.25 17.2417 11.25 16.5C11.25 15.5054 10.8549 14.5516 10.1516 13.8484C9.44839 13.1451 8.49456 12.75 7.5 12.75ZM7.5 18.75C7.05499 18.75 6.61998 18.618 6.24997 18.3708C5.87996 18.1236 5.59157 17.7722 5.42127 17.361C5.25097 16.9499 5.20642 16.4975 5.29323 16.061C5.38005 15.6246 5.59434 15.2237 5.90901 14.909C6.22368 14.5943 6.62459 14.3801 7.06105 14.2932C7.4975 14.2064 7.9499 14.251 8.36104 14.4213C8.77217 14.5916 9.12357 14.88 9.37081 15.25C9.61804 15.62 9.75 16.055 9.75 16.5C9.75 17.0967 9.51295 17.669 9.09099 18.091C8.66903 18.5129 8.09674 18.75 7.5 18.75ZM20.25 16.5C20.25 16.6989 20.171 16.8897 20.0303 17.0303C19.8897 17.171 19.6989 17.25 19.5 17.25H17.25V19.5C17.25 19.6989 17.171 19.8897 17.0303 20.0303C16.8897 20.171 16.6989 20.25 16.5 20.25C16.3011 20.25 16.1103 20.171 15.9697 20.0303C15.829 19.8897 15.75 19.6989 15.75 19.5V17.25H13.5C13.3011 17.25 13.1103 17.171 12.9697 17.0303C12.829 16.8897 12.75 16.6989 12.75 16.5C12.75 16.3011 12.829 16.1103 12.9697 15.9697C13.1103 15.829 13.3011 15.75 13.5 15.75H15.75V13.5C15.75 13.3011 15.829 13.1103 15.9697 12.9697C16.1103 12.829 16.3011 12.75 16.5 12.75C16.6989 12.75 16.8897 12.829 17.0303 12.9697C17.171 13.1103 17.25 13.3011 17.25 13.5V15.75H19.5C19.6989 15.75 19.8897 15.829 20.0303 15.9697C20.171 16.1103 20.25 16.3011 20.25 16.5Z"
                        fill="#575757"
                      />
                    </svg>
                    <span className="hide-menu">Others</span>
                  </a>
                  <ul
                    aria-expanded="false"
                    className="collapse"
                    id="loans"
                    onClick={() => this.handleChangeTab("others")}
                  >
                    <li>
                      {" "}
                      <NavLink to={`/backup`}>DB Backups</NavLink>
                    </li>
                    <li>
                      {" "}
                      <NavLink to={`/sheet-list`}>Sheet List</NavLink>
                    </li>
                  </ul>
                </li>
              )}
            </ul>
          </nav>
        </div>
      </aside>
    );
  }
}

const mapStateToProps = (state) => ({
  authentication: state.authentication,
  callmanagement: state.callmanagement,
  util: state.util,
});

const mapDispatchToProps = (dispatch) => ({
  getNotificationAll: (objectId, page, role) =>
    dispatch(getNotificationAll(objectId, page, role)),

  dispatch,
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Sidemenu)
);
